import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Popup from "components/common/Popup";

import styles from "./styles.module.scss";
import Button from "components/common/Button";

const Terms = ({ previousLocation }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const lang = useSelector((state) => state.settings.lang);

    const handleClose = useCallback(() => {
        navigate(previousLocation);
    }, [navigate, previousLocation]);

    return (
        <Popup title={t("footer.terms")} onClose={handleClose}>
            <div className={styles.terms}>
                {lang === "en" ? (
                    <>
                        <p>
                            The website located at www.blago.pro (the <strong>“Site”</strong>) are
                            copyrighted works belonging to BLAGO OÜ. (<strong>“BLAGO”</strong>, and
                            <strong>“we”</strong>). BLAGO provides a service (
                            <strong>“Service”</strong>) that connects motor carrier businesses (
                            <strong>“Carriers”</strong>) to entities who need to ship cargo
                            (consignor, consignee, or any other entity with an interest in cargo)
                            <strong>“Shipper”</strong>.
                        </p>
                        <p>
                            THESE TERMS OF SERVICE AS REVISED BY BLAGO IN ITS SOLE DISCRETION FROM
                            TIME TO TIME (THIS “AGREEMENT”) SET FORTH THE LEGALLY BINDING TERMS FOR
                            YOUR USE OF THE SERVICE. BY ACCESSING OR USING THE SERVICE, YOU ARE
                            ACCEPTING THIS AGREEMENT, ON BEHALF OF YOURSELF OR THE COMPANY, ENTITY
                            OR ORGANIZATION THAT YOU REPRESENT, AND YOU REPRESENT AND WARRANT THAT
                            YOU HAVE THE RIGHT, AUTHORITY, AND CAPACITY TO ENTER INTO THIS
                            AGREEMENT, ON BEHALF OF YOURSELF OR THE COMPANY, ENTITY OR ORGANIZATION
                            THAT YOU REPRESENT. YOU MAY NOT ACCESS OR USE THE SERVICE OR ACCEPT THIS
                            AGREEMENT IF YOU ARE NOT AT LEAST 18 YEARS OLD.
                        </p>
                        <p>
                            IF YOU DO NOT AGREE WITH ALL OF THE PROVISIONS OF THIS AGREEMENT, DO NOT
                            ACCESS OR USE THE SERVICE.
                        </p>
                        <h2>1 SERVICE DESCRIPTION</h2>
                        <p>
                            <strong>1.1. General</strong>. BLAGO helps to connect Shippers and
                            Carriers for the shipment of local freight and cargo by providing a
                            platform whereby Shippers can post details of desired shipment requests
                            and Carriers can accept such shipment requests. “User” means any user of
                            the Service, and may be a Carrier or a Shipper, or a representative of
                            either. To the extent you are a Carrier, the provisions in this
                            Agreement regarding Carriers apply to you. To the extent you are a
                            Shipper, the provisions in this Agreement regarding Shippers apply to
                            you. To the extent you are a User, the provisions in this Agreement
                            regarding Users apply to you. For the avoidance of doubt, BLAGO only
                            provides the platform for posting and accepting Shipments, but do not
                            provide shipping services.
                        </p>
                        <p>
                            <strong>1.2. Shipment Requests</strong>. Shipper may post a request for
                            a shipment (“Shipment”) through the Service. Without limitation, Shipper
                            will provide origin and destination addresses, the requested date and
                            pickup time of the Shipment, a description of the items being shipped
                            and any other relevant information about the Shipment.  BLAGO is not
                            responsible for any Shipment terms. As a result the Shipment will be
                            viewable to all relevant Carriers. Shippers may cancel a Shipment at any
                            time prior to it being accepted by a Carrier. Carriers may view a list
                            of the available at any time and accept a Shipment through the Service.
                            The first Carrier to accept a Shipment will be assigned the Shipment.
                            Once accepted by a Carrier, BLAGO will notify Shipper that the Shipment
                            has been accepted. BLAGO does not guarantee that a Shipment will be
                            accepted by a Carrier. If a Shipment is not accepted by a Carrier, BLAGO
                            will notify the Shipper that no Carrier is available.
                        </p>
                        <h2>2. CARRIER TERMS, REPRESENTATIONS AND WARRANTIES</h2>
                        <p>
                            <strong>2.1. Carrier Minimal Requirements</strong>. As a Carrier, you
                            hereby represent, warrant and covenant that:
                        </p>
                        <ol>
                            <li>
                                You are duly authorized to provide shipping services as a contract
                                carrier of commodities and desire to provide shipping services for
                                Shipments.
                            </li>
                            <li>
                                You currently, and shall during all periods you transport shipments
                                through the Service, have all applicable licenses, permits,
                                registrations, approvals and authority under the applicable law to
                                provide the shipping services subject to this Agreement.
                            </li>
                            <li>
                                all equipment used is in full compliance with the applicable
                                regulations.
                            </li>
                        </ol>
                        <p>
                            <strong>2.2. Equipment</strong>. With respect to the equipment you use
                            to perform shipping services under these Terms of Service, you hereby
                            represent, warrant and covenant that:
                        </p>
                        <p>
                            (a) You will, at your sole cost and expense, furnish all equipment
                            required for the performance of shipping services under these Terms of
                            Service, and pay all expenses related to the use or operation and
                            maintenance of such equipment (including any fines, penalties or fees).
                        </p>
                        <p>
                            (b) You will provide equipment that is in compliance with all applicable
                            governmental regulatory standards, testing, requirements, licensing,
                            titling, permits and registration, and sufficient in quality and
                            quantity to meet the transportation needs of each shipment you agree to
                            transport.
                        </p>
                        <p>
                            <strong>2.3. Employees And Services</strong>. With respect to your
                            employees who carry out shipping services pursuant to these Terms of
                            Service, you hereby represent, warrant and covenant that:
                        </p>
                        <p>
                            (a) You will employ and be solely responsible for all personnel employed
                            or contracted by you to provide shipping services.
                        </p>
                        <p>
                            (b) You have sole responsibility for any and all acts and omissions of
                            your drivers, and such drivers’ compliance with all applicable laws and
                            regulations.
                        </p>
                        <p>
                            (c) You are solely responsible for the interviewing, hiring, training,
                            disciplining, and termination of your drivers and other employees.
                        </p>
                        <p>
                            (d) You shall utilize only drivers and other operating personnel who are
                            licensed to perform all services for which they are engaged.
                        </p>
                        <p>
                            <strong>2.4. Shipper Instructions</strong>. In the event the Shipper
                            gives specific instructions regarding the proper loading, handling and
                            shipping of freight, such terms shall govern, and you, as a Carrier,
                            shall comply therewith.
                        </p>
                        <p>
                            <strong>2.5. Acceptance of Liability.</strong> As a Carrier, you hereby
                            represent, warrant and covenant that:
                        </p>
                        <p>
                            (a) You are solely responsible for any and all liability which results
                            or is alleged as a result of the services you provide under this
                            Agreement, including, but not limited to, property damage, cargo loss,
                            damages or delay, personal injury and death (including, but not limited
                            to, liabilities related to your own property and employees). Your
                            liability in all cases shall be as a motor carrier. Your liability is
                            for the full amount of any such loss, damage, cost or other liabilities,
                            irrespective of your insurance limits.
                        </p>
                        <p>
                            (b) You agree to defend, indemnify, hold harmless and/or make whole
                            BLAGO, Shippers and consignees (and their officers, employees, and
                            agents) (collectively, the “Shipper Indemnities”), with respect to any
                            and all claims, demands, loss, damage, expenses (including costs and
                            attorney’s fees), or liability (collectively “Claims”) due to or arising
                            out of your or your drivers’ or other agents’: (i) use of the Service;
                            (ii) use of or access to User Content; (iii) interaction with any other
                            User; (iv) violation of any of the terms of this Agreement; (v) driver
                            salaries, wage, overtime and meal/rest period claims, local and federal
                            payroll and other withholding taxes, unemployment insurance, pensions,
                            workers’ compensation, social security and related protections, and any
                            expenses related to equipment and fuel; (vi) violation of applicable
                            laws or regulations; or (vii) performance of transportation services
                            using the Service. The foregoing obligations shall not apply to the
                            benefit of any individual Shipper Indemnity to the extent a court of
                            appropriate jurisdiction has determined such Shipper Indemnity to be
                            responsible for a Claim. This indemnification applies regardless of any
                            provisions in separate contracts between BLAGO and third parties. You
                            also hereby waive any claims or demands by you against the Shipper
                            Indemnities related to any costs, losses, expenses or liability arising
                            from the above-listed actions by you or your agents.
                        </p>
                        <p>
                            (c) Without limiting any of the foregoing provisions, you specifically
                            agree to defend, indemnify, hold harmless and/or make whole the Shipper
                            Indemnities for Claims due to or arising out of your, or your drivers’
                            or other agents’:
                        </p>
                        <p>
                            (i) Failure to use commercially reasonable efforts to pick up accepted
                            Shipments at the designated point of origin within as soon as is
                            practicable, or use commercially reasonable efforts to proceed to the
                            point of destination specified or perform timely, efficient and reliable
                            pick-up and delivery of all shipments.
                        </p>
                        <p>
                            (ii) Improper or unsafe loading or unloading of any shipment, or, where
                            you are not required to load, failure to determine, to the extent you
                            are able to ascertain through ordinary inspection, that each shipment
                            was properly loaded.
                        </p>
                        <p>
                            (iii) Shipment of any loads in violation of applicable weight, axle, or
                            other applicable laws and regulations, or Shipper’s specific
                            instructions.
                        </p>
                        <p>
                            (iv) Suspension of service at any time after loaded dispatch, or delay
                            of service by stop over for any reason that would leave your equipment
                            and the cargo unattended without adequate security as a prudent Carrier
                            would or as is otherwise required under your insurance policies.
                        </p>
                        <p>
                            (v) Acceptance of any shipments for which you cannot comply with
                            applicable temperature requirements, and any damage as a result of
                            failure to comply with such requirements.
                        </p>
                        <p>
                            (vi) Use of equipment that has been used for the transportation of any
                            waste of any kind, garbage, or any other commodity which results in the
                            contamination of other shipments.
                        </p>
                        <p>
                            (vii) Failure to inspect and/or investigate if a shipment contains
                            hazardous material, acceptance of hazardous material, and violation of
                            any applicable laws and regulations related to the transport of
                            hazardous material.
                        </p>
                        <p>
                            (viii) Disengagement or detachment of your power unit from the trailer,
                            container/chassis, flatbed or other equipment at any time unless
                            emergency or exceptional circumstances require it.
                        </p>
                        <p>
                            (ix) Failure to perform the services under this Agreement in a good and
                            workmanlike manner in accordance with standards of the trade.
                        </p>
                        <p>
                            (x) Failure to utilize equipment that is in good and safe operating
                            condition, clean, insect and rodent free, odor free, mold free, sealed
                            from water and/or moisture damage, safe, properly maintained and
                            hazard-free.
                        </p>
                        <p>
                            (d) BLAGO reserves the right, at your expense, to assume the exclusive
                            defense and control of any matter for which you are required to
                            indemnify us and you agree to cooperate with our defense of these
                            claims. You agree not to settle any matter without the prior written
                            consent of BLAGO. BLAGO will use reasonable efforts to notify you of any
                            such claim, action or proceeding upon becoming aware of it.
                        </p>
                        <h2>3. SHIPPER TERMS, REPRESENTATIONS AND WARRANTIES</h2>
                        <p>
                            <strong>3.1. Representations and Warranties</strong>. If you are a
                            Shipper, you hereby represent, warrant and covenant that:
                        </p>
                        <p>
                            (a) You own the shipped items or have the necessary rights to ship such
                            items and are authorized to, and do, bind the owner to the provisions of
                            this Agreement.
                        </p>
                        <p>
                            (b) You use the Service to ship items at your own risk through the motor
                            carriers that use the Service and, except to the limited extent
                            expressly set forth in this Agreement, agree that BLAGO will have no
                            liability for any shipped items or any claims, demands, loss or damages
                            related thereto.
                        </p>
                        <p>
                            (c) You are solely responsible for any and all liability, which results
                            or is alleged as a result of such shipped items, including, but not
                            limited to, property damage, personal injury and death.
                        </p>
                        <p>
                            (d) If you are loading, bracing and securing your goods, you understand
                            that you are liable for any claims, loss, or damage as a result of your
                            doing so improperly or unsafely. You understand that BLAGO is in no way
                            responsible for the securing, lading, packaging, or compliance with
                            shipping instructions for your shipments.
                        </p>
                        <p>
                            (e) You understand that BLAGO is not a motor carrier, and as such, is
                            not liable or responsible to you or the recipient of cargo for any cargo
                            shipped under this Agreement.
                        </p>
                        <p>
                            (f) You understand that tracking the locations of your shipments through
                            the Service does not guarantee that such shipments will be delivered to
                            you at the time specified.
                        </p>
                        <p>
                            <strong>3.3. Prohibited Items</strong>. Shippers shall not use the
                            Service to ship the below items and waives any and all liability of the
                            Carrier and BLAGO with respect to any loss of or damage to any of the
                            following:
                        </p>
                        <p>
                            (a) Contraband or items that are illegal, dangerous, radioactive,
                            harmful, unsafe, offensive or objectionable;
                        </p>
                        <p>
                            (b) Bullion, precious metals, precious metal objects, gold, silver,
                            platinum, precious or semi-precious stones (including but not limited to
                            diamonds, emeralds, sapphires and rubies), and precious jewelry which
                            includes jewelry made from precious metals and stones;
                        </p>
                        <p>
                            (c) Money, securities, accounts, bills, currency, food stamps, lottery
                            tickets, notes, bank notes, coins, bonds, negotiable instruments or
                            evidences of debt, passports, tickets, documents, manuscripts, records,
                            or other valuable papers;
                        </p>
                        <p>(d) Tobacco products and processed tobacco;</p>
                        <p>(e) Bottled spirits;</p>
                        <p>
                            (f) Valuable works of art which includes antiques, paintings,
                            sculptures, tapestries, collectibles or other objects for display; or
                        </p>
                        <p>(h) Bloodstock and live animals including cattle or poultry.</p>
                        <p>
                            <strong>3.4. Shipper Indemnification</strong>. You agree to defend,
                            indemnify, hold harmless and/or make whole BLAGO (and its officers,
                            employees, and agents) (each, an “Carrier Indemnity”) with respect to
                            any and all Claims due to or arising out of your or your agents’: (a)
                            use of the Service; (b) use of or access to User Content; (c)
                            interaction with any other User; (d) violation of this Agreement; (e)
                            violation of applicable laws or regulations; or (f) your shipment
                            contents. BLAGO reserves the right, at your expense, to assume the
                            exclusive defense and control of any matter for which you are required
                            to indemnify us and you agree to cooperate with our defense of these
                            claims.  The foregoing obligations shall not apply to the extent a court
                            of appropriate jurisdiction has determined any Claim to have been caused
                            by the negligence or intentional misconduct of BLAGO. You agree not to
                            settle any matter without the prior written consent of BLAGO. BLAGO will
                            use reasonable efforts to notify you of any such claim, action or
                            proceeding upon becoming aware of it. This indemnification with respect
                            to BLAGO applies regardless of any provisions in separate contracts
                            between BLAGO and third parties. You also hereby waive any claims or
                            demands by you against BLAGO related to any costs, loss, expenses or
                            liability arising from the above-listed actions by you or your agents.
                        </p>
                        <h2>4. CARGO CLAIMS</h2>
                        <p>
                            <strong>4.1. Carrier Liability</strong>. (a) Carrier agrees to assume
                            full liability for the prompt, safe transportation of all shipments
                            under this Agreement. Carrier’s liability to BLAGO, Shipper and/or any
                            involved consignor or consignee, shall be the invoice value of the goods
                            transported, without limitation.
                        </p>
                        <p>
                            <strong>4.2. BLAGO Limitation of Liability.</strong> Shipper understands
                            and agrees that Carrier is primarily liable for cargo loss and damage
                            and BLAGO is not liable for the acts or omissions of Carrier. Unless a
                            separate written contract with a customer signed by an officer of both
                            BLAGO and such customer provides otherwise, BLAGO’s sole liability with
                            respect to loss or damage, including due to unreasonable delay, to cargo
                            shall be to the extent that such loss or damage, is caused by the
                            negligence or intentional misconduct of BLAGO.  BLAGO’s liability for
                            such cargo loss or damage shall in no event exceed the lesser of: (i)
                            the cost to repair or replace the goods in question; (ii) $0.1 per lb.
                            per package; and (iii) $500 per occurrence.  The sole liability of
                            BLAGO, and the sole recovery of the Shipper or owner against BLAGO, with
                            respect to loss, damage or delay shall be as set forth in this
                            provision.  Without limiting the foregoing, in no event is BLAGO
                            responsible for the acts or omissions of any third party, including any
                            Carrier, including, but not limited to, a Carrier’s denial of a valid
                            claim or failure to comply with Shipper’s instructions.
                        </p>
                        <p>
                            <strong>.3. Claim Submissions and Settlement</strong>. (a) In the event
                            of loss or damage, Shipper or any consignor or consignee shall endeavor
                            to submit a claim to Carrier within ninety (90) days of the incident,
                            and in no event later than six (6) months of the incident. Unless agreed
                            in a separate written contract, Shipper is not entitled to offset the
                            amount of any claims, which remain unpaid or unresolved against amounts
                            owed by Shipper to BLAGO.  Shipper shall not assert a claim for cargo
                            loss or damage, and neither BLAGO nor the Carrier shall be liable for
                            cargo loss or damage, in instances where there is no affirmative proof
                            of loss or damage to cargo.
                        </p>
                        <p>
                            (b) Carriers shall settle claims within sixty (60) days of Carrier’s
                            receipt of all necessary claims documentation.
                        </p>
                        <h2>5. PAYMENT TERMS</h2>
                        <p>
                            <strong>5.1. Shipper Payment and Charges</strong>.
                        </p>
                        <p>
                            (a) For each Shipment, Shipper is obligated to pay the fee directly to
                            the Carrier (“Shipment Fee”).
                        </p>
                        <h2>6. LICENSES</h2>
                        <p>
                            <strong>6.1. Accounts</strong>. In order to use certain features of the
                            Service, you must register for an account with BLAGO (“Account”) and
                            provide certain information as prompted by the registration form. You
                            represent and warrant that: (a) all required registration information
                            you submit is truthful and accurate; and (b) you will maintain the
                            accuracy of such information. You may delete your Account at any time,
                            for any reason, by following the instructions on the Service. You are
                            responsible for maintaining the confidentiality of your Account login
                            credentials and are fully responsible for all activities that occur
                            under your Account. Each Account may only be used to access the Service
                            during one (1) concurrent login session. You agree to immediately notify
                            BLAGO of any unauthorized use, or suspected unauthorized use of your
                            Account or any other breach of security. BLAGO cannot and will not be
                            liable for any loss or damage arising from your failure to comply with
                            the above requirements.
                        </p>
                        <p>
                            <strong>6.2. Site</strong>. Subject to the terms of this Agreement,
                            BLAGO grants you a non-transferable, nonexclusive, license to use the
                            Site for your internal business use during the term of this Agreement.
                        </p>
                        <p>
                            <strong>6.3. Certain Restrictions</strong>. The rights granted to you in
                            this Agreement are subject to the following restrictions: (a) you shall
                            not license, sell, rent, lease, transfer, assign, distribute, host, or
                            otherwise commercially exploit the Service; (b) you shall not modify,
                            make derivative works of, disassemble, reverse compile or reverse
                            engineer any part of the Service; (c) you shall not access the Service
                            in order to build a similar or competitive service; and (d) except as
                            expressly stated herein, no part of the Service may be copied,
                            reproduced, distributed, republished, downloaded, displayed, posted or
                            transmitted in any form or by any means. Any future release, update, or
                            other addition to functionality of the Service shall be subject to the
                            terms of this Agreement. All copyright and other proprietary notices on
                            any Service content must be retained on all copies thereof.
                        </p>
                        <p>
                            <strong>6.4. Limited Support</strong>. Users may contact BLAGO’s
                            technical support center for any support related issues arising from the
                            use of the Service by following the instructions on the Service.
                        </p>
                        <h2>7. OWNERSHIP</h2>
                        <p>
                            <strong>7.1. Ownership</strong>. Excluding your User Content (defined
                            below), you acknowledge that all the intellectual property rights,
                            including copyrights, patents, trademarks, and trade secrets, in the
                            Service are owned by BLAGO or BLAGO’s licensors. The provision of the
                            Service does not transfer to you or any third party any rights, title or
                            interest in or to such intellectual property rights. BLAGO and its
                            suppliers reserve all rights not granted in this Agreement.
                        </p>
                        <p>
                            <strong>7.2. Modification</strong>. BLAGO reserves the right, at any
                            time, to modify, suspend, or discontinue the Service or any part thereof
                            with or without notice. You agree that BLAGO will not be liable to you
                            or to any third party for any modification, suspension, or
                            discontinuance of the Service or any part thereof.
                        </p>
                        <p>
                            <strong>7.3. Feedback</strong>. If you provide BLAGO any feedback,
                            suggestions, bug reports, system errors, and other information or ideas
                            regarding the Service (“Feedback”), you hereby assign to BLAGO all
                            rights in the Feedback and agree that BLAGO shall have the right to use
                            such Feedback and related information in any manner it deems
                            appropriate. Without limiting the foregoing, this assignment of rights
                            applies to any testimonials you provide, and you hereby also grant BLAGO
                            the right to use your name in connection with sharing such testimonials
                            with the public. BLAGO will treat any Feedback you provide to BLAGO as
                            non-confidential and non-proprietary. You agree that you will not submit
                            to BLAGO any information or ideas that you consider to be confidential
                            or proprietary. If you agree to participate in any case studies, you
                            agree that information you provide in connection with the case study is
                            deemed Feedback and that BLAGO may use your name in connection with such
                            Feedback.
                        </p>
                        <h2>8. USER CONTENT</h2>
                        <p>
                            <strong>8.1. User Content</strong>. “User Content” means any and all
                            information, data, and other content that a User submits to, or uses
                            with, the Service. User Content includes the information provided in a
                            Shipment request or acceptance. You are solely responsible for your User
                            Content. You assume all risks associated with use of your User Content,
                            including any reliance on its accuracy, completeness or usefulness by
                            others, or any disclosure of your User Content that makes you or any
                            third party personally identifiable. You hereby represent and warrant
                            that your User Content does not violate the Acceptable Use Policy
                            (defined below). For the avoidance of doubt, User Content may include
                            third party content you submit. You agree not to submit third party
                            content unless you have the consent of the applicable third party owner
                            of such content. You may not state or imply that your User Content is in
                            any way provided, sponsored or endorsed by BLAGO. Because you alone are
                            responsible for your User Content (and not BLAGO), you may be exposed to
                            liability if, for example, your User Content violates the Acceptable Use
                            Policy. Because we do not control User Content, you acknowledge and
                            agree that we are not responsible for any User Content and we make no
                            guarantees regarding the accuracy, currency, suitability, or quality of
                            any User Content, and we assume no responsibility for any User Content.
                        </p>
                        <p>
                            <strong>8.2. License</strong>. You hereby grant, and you represent and
                            warrant that you have the right to grant, to BLAGO an irrevocable,
                            nonexclusive, royalty-free and fully paid, sublicense-able, worldwide
                            license, to use your User Content, for the purposes of including your
                            User Content in the Service, to create Anonymous Data, and as provide in
                            the BLAGO Privacy Policy (the “Privacy Policy”). All rights in and to
                            the User Content not expressly granted to BLAGO in this Agreement or the
                            Privacy Policy are reserved by you.
                        </p>
                        <h2>9. ACCEPTABLE USE POLICY</h2>
                        <p>The following sets forth BLAGO’s “Acceptable Use Policy”:</p>
                        <p>
                            <strong>9.1</strong>. You agree not to use the Service to collect,
                            upload, transmit, display, or distribute any User Content (a) that
                            violates any third-party right, including any copyright, trademark,
                            patent, trade secret, moral right, privacy right, right of publicity, or
                            any other intellectual property or proprietary right; (b) that is
                            unlawful, harassing, abusive, tortious, threatening, harmful, invasive
                            of another’s privacy, vulgar, defamatory, false, intentionally
                            misleading, trade libelous, pornographic, obscene, patently offensive
                            (e.g., material that promotes racism, bigotry, hatred, or physical harm
                            of any kind against any group or individual) or otherwise objectionable
                            material of any kind or nature or which is harmful to minors in any way;
                            or (c) in violation of any law, regulation, or obligations or
                            restrictions imposed by any third party.
                        </p>
                        <p>
                            <strong>9.2</strong>. In addition, you agree not to use the Service to:
                            (a) upload, transmit, or distribute any computer viruses, worms, or any
                            software intended to damage or alter a computer system or data; (b) send
                            unsolicited or unauthorized advertising, promotional materials, junk
                            mail, spam, chain letters, pyramid schemes, or any other form of
                            duplicative or unsolicited messages, whether commercial or otherwise;
                            (c) harvest, collect, gather or assemble information or data regarding
                            other Users, including e-mail addresses, without their consent; (d)
                            interfere with, disrupt, or create an undue burden on servers or
                            networks connected to the Service or violate the regulations, policies
                            or procedures of such networks; (e) attempt to gain unauthorized access
                            to the Service, other computer systems or networks connected to or used
                            together with the Service, through password mining or other means; (f)
                            harass or interfere with another User’s use and enjoyment of the
                            Service; or (g) introduce software or automated Agents or scripts to the
                            Service so as to produce multiple accounts, generate automated searches,
                            requests and queries, or to strip, scrape, or mine data from the
                            Service.
                        </p>
                        <p>
                            We reserve the right (but have no obligation) to review any User
                            Content, investigate, and/or take appropriate action against you in our
                            sole discretion (including removing or modifying your User Content,
                            terminating your Account in accordance with Section 10, and/or reporting
                            you to law enforcement authorities) if you violate the Acceptable Use
                            Policy or any other provision of this Agreement or otherwise create
                            liability for us or any other person.
                        </p>
                        <h2>10. TERM AND TERMINATION</h2>
                        <p>
                            <strong>10.1</strong>. Subject to this Section, this Agreement will
                            remain in full force and effect while you use the Service. BLAGO may at
                            any time terminate this Agreement with you in its sole discretion if (a)
                            you have breached any provision of this Agreement, the applicable SOP or
                            Work Order (or have acted in a manner that clearly shows you do not
                            intend to, or are unable to, comply with this Agreement); (b) BLAGO is
                            required to do so by law (for example, where the provision of the
                            Service to you is, or becomes, unlawful); or (c) BLAGO has elected to
                            discontinue the Service as described in Section 7.2. Upon termination of
                            this Agreement, your Account and right to access and use the Service
                            will terminate immediately. BLAGO will not have any liability whatsoever
                            to you for any termination of the Service, including for termination of
                            your Account or deletion of your User Content. Even after this Agreement
                            is terminated, the following provisions of this Agreement will remain in
                            effect: Sections 6.4, Section 7 through and inclusive of Section 16.
                        </p>
                        <h2>11. DISCLAIMERS AND RELEASE</h2>
                        <p>
                            <strong>11.1</strong>. THE SERVICE IS PROVIDED “AS-IS” AND WE (AND OUR
                            SUPPLIERS) EXPRESSLY DISCLAIM ANY WARRANTIES AND CONDITIONS OF ANY KIND,
                            WHETHER EXPRESS OR IMPLIED, INCLUDING THE WARRANTIES OR CONDITIONS OF
                            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET
                            ENJOYMENT, ACCURACY, OR NONINFRINGEMENT. WE (AND OUR SUPPLIERS) MAKE NO
                            WARRANTY THAT THE SERVICE: (A) WILL MEET YOUR REQUIREMENTS OR
                            EXPECTATIONS; (B) WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE,
                            OR ERROR-FREE BASIS; (C) WILL BE ACCURATE, RELIABLE, FREE OF VIRUSES OR
                            OTHER HARMFUL CODE, COMPLETE, LEGAL, OR SAFE; OR (D) RESULT IN ANY
                            REVENUE, PROFITS, OR COST REDUCTION. THE SERVICE MAY BE SUBJECT TO
                            LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN THE USE OF THE
                            INTERNET AND ELECTRONIC COMMUNICATIONS. WE ARE NOT RESPONSIBLE FOR ANY
                            DELAYS, DELIVERY FAILURES OR OTHER DAMAGES RESULTING FROM SUCH PROBLEMS.
                        </p>
                        <p>
                            <strong>11.2</strong>. BLAGO OFFERS A PLATFORM TO CONNECT SHIPPERS AND
                            CARRIERS, BUT DOES NOT AND DOES NOT INTEND TO PROVIDE SHIPPING SERVICES
                            OR ACT IN ANY WAY AS A CARRIER, COURIER, OR SHIPPING PROVIDER. IT IS UP
                            TO THE THIRD PARTY CARRIER TO PROVIDE SHIPPING SERVICES, WHICH MAY BE
                            SCHEDULED THROUGH THE USE OF THE SERVICE. BLAGO HAS NO RESPONSIBILITY OR
                            LIABILITY FOR ANY SHIPPING SERVICES PROVIDED TO SHIPPERS BY SUCH THIRD
                            PARTY CARRIERS. BLAGO SHALL NOT BE DEEMED TO BE AN AGENT OR A PARTNER OF
                            CARRIER OR SHIPPER FOR ANY REASON. CARRIERS SHALL NOT BE DEEDED TO BE A
                            SUBCONTRACTOR OR EMPLOYEE OF BLAGO FOR ANY REASON. ANY DISPUTE SHIPPERS
                            HAVE WITH ANY CARRIER OR OTHER THIRD PARTY, INCLUDING WITHOUT LIMITATION
                            ANY OTHER USER OF THE SERVICE, IS DIRECTLY BETWEEN THE SHIPPER ANY SUCH
                            THIRD PARTY.
                        </p>
                        <p>
                            <strong>11.3</strong>. WE MAKE NO WARRANTY REGARDING THE SUITABILITY,
                            LEGALITY, REGULATORY COMPLIANCE, QUALITY OR ABILITY OF ANY CARRIERS,
                            SHIPPERS, SHIPPED ITEMS AND SHIPPING SERVICES SCHEDULED THROUGH THE USE
                            OF THE SERVICE. BY USING THE SERVICE, YOU OR YOUR SHIPMENTS MAY BE
                            EXPOSED TO SITUATIONS THAT ARE POTENTIALLY DANGEROUS, OFFENSIVE,
                            HARMFUL, UNSAFE OR OTHERWISE OBJECTIONABLE. YOU USE THE SERVICE AT YOUR
                            OWN RISK. YOUR INTERACTIONS WITH OTHER USERS AND THIRD PARTIES ARE
                            SOLELY BETWEEN YOU AND SUCH USER OR THIRD PARTY. YOU AGREE THAT BLAGO
                            WILL NOT BE RESPONSIBLE FOR ANY LOSS OR DAMAGE INCURRED AS THE RESULT OF
                            ANY SUCH INTERACTIONS. IF THERE IS A DISPUTE BETWEEN YOU AND ANY USER OR
                            THIRD PARTY, WE ARE UNDER NO OBLIGATION TO BECOME INVOLVED.
                        </p>
                        <p>
                            <strong>11.4</strong>. YOU HEREBY WAIVE AND RELEASE BLAGO (AND OUR
                            SUPPLIERS, OFFICERS, EMPLOYEES, AGENTS, SUCCESSORS AND ASSIGNS) FROM,
                            AND HEREBY WAIVE AND RELINQUISH, EACH AND EVERY PAST, PRESENT AND FUTURE
                            DISPUTE, CLAIM, CONTROVERSY, DEMAND, RIGHT, OBLIGATION, LIABILITY,
                            ACTION AND CAUSE OF ACTION OF EVERY KIND AND NATURE (INCLUDING PERSONAL
                            INJURIES, DEATH, AND PROPERTY DAMAGE), ARISING FROM YOUR USE OF THE
                            SERVICE, OR IN ANY WAY RELATED TO OTHER USERS OR THIRD PARTIES EXCEPT TO
                            THE EXTENT, IF ANY, THAT LIABILITY HAS OTHERWISE BEEN EXPRESSLY ASSUMED
                            IN THIS AGREEMENT.
                        </p>
                        SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE
                        ABOVE EXCLUSION MAY NOT APPLY TO YOU.
                        <h2>12. LIMITATION ON LIABILITY</h2>
                        <p>
                            <strong>12.1</strong>. IN NO EVENT SHALL WE (AND OUR SUPPLIERS) BE
                            LIABLE TO YOU OR ANY THIRD PARTY FOR ANY PERSONAL INJURY OR LOST PROFIT
                            OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR
                            PUNITIVE DAMAGES ARISING FROM OR RELATING TO THIS AGREEMENT OR YOUR USE,
                            INCLUDING WITHOUT LIMITATION, USING THE SERVICE IN VIOLATION OF TRAFFIC
                            OR SAFETY LAWS, OR INABILITY TO USE THE SERVICE, EVEN IF WE HAVE BEEN
                            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO
                            THE CONTRARY CONTAINED HEREIN, EXCEPT AS PROVIDED IN SECTION 4.2, OUR
                            (AND OUR SUPPLIERS’) LIABILITY TO YOU FOR ANY DAMAGES ARISING FROM OR
                            RELATED TO THIS AGREEMENT OR THE SERVICE (FOR ANY CAUSE WHATSOEVER AND
                            REGARDLESS OF THE FORM OF THE ACTION), WILL AT ALL TIMES BE LIMITED TO
                            THE GREATER OF (A) FIFTY US DOLLARS ($50) OR (B) AMOUNTS YOU HAVE PAID
                            BLAGO IN THE PRIOR 12 MONTHS (IF ANY). THE EXISTENCE OF MORE THAN ONE
                            CLAIM WILL NOT ENLARGE THIS LIMIT.
                        </p>
                        SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR
                        INCIDENTAL OF CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION
                        MAY NOT APPLY TO YOU AND YOU MAY ALSO HAVE OTHER LEGAL RIGHTS THAT VARY FROM
                        JURISDICTION TO JURISDICTION.
                        <h2>13. THIRD PARTY SITES & ADS</h2>
                        <p>
                            The Service might contain links to third party websites, services, and
                            advertisements for third parties (collectively, “Third Party Sites &
                            Ads”). Such Third Party Sites & Ads are not under the control of BLAGO
                            and BLAGO is not responsible for any Third Party Sites & Ads. BLAGO
                            provides these Third Party Sites & Ads only as a convenience and does
                            not review, approve, monitor, endorse, warrant, or make any
                            representations with respect to Third Party Sites & Ads. You use all
                            Third Party Sites & Ads at your own risk. When you link to a Third Party
                            Site & Ad, the applicable third party’s terms and policies apply,
                            including the third party’s privacy and data gathering practices. You
                            should make whatever investigation you feel necessary or appropriate
                            before proceeding with any transaction in connection with such Third
                            Party Sites & Ads.
                        </p>
                        <h2>14. COPYRIGHT POLICY</h2>
                        <p>
                            <strong>14.1</strong>. BLAGO respects the intellectual property of
                            others and asks that Users of our Service do the same. In connection
                            with the Service, we have adopted and implemented a policy respecting
                            copyright law that provides for the removal of any infringing materials
                            and for the termination, in appropriate circumstances, of Users who are
                            repeat infringers of intellectual property rights, including copyrights.
                            If you believe that one of our Users is, through the use of the Service,
                            unlawfully infringing the copyright(s) in a work, and wish to have the
                            allegedly infringing material removed, the following information in the
                            form of a written notification must be provided to our authorized
                            representative by email specified in this Agreement or designated
                            Copyright Agent (if any): 1. your physical or electronic signature; 2.
                            identification of the copyrighted work(s) that you claim to have been
                            infringed; 3. identification of the material on our services that you
                            claim is infringing and that you request us to remove; 4. sufficient
                            information to permit us to locate such material; 5. your address,
                            telephone number, and e-mail address; 6. a statement that you have a
                            good faith belief that use of the objectionable material is not
                            authorized by the copyright owner, its agent, or under the law; and 7. a
                            statement that the information in the notification is accurate, and
                            under penalty of perjury, that you are either the owner of the copyright
                            that has allegedly been infringed or that you are authorized to act on
                            behalf of the copyright owner. Please note that, any misrepresentation
                            of material fact (falsities) in a written notification automatically
                            subjects the complaining party to liability for any damages, costs and
                            attorney’s fees incurred by us in connection with the written
                            notification and allegation of copyright infringement.
                        </p>
                        {/* <h2>
                            15. AMENDMENT AND MODIFICATIONS OF THIS AGREEMENT
                        </h2> */}
                        {/* <p>
                            This Agreement is periodically reviewed, modified and enhanced as
                            necessary. Please revisit the Terms of Service periodically to stay
                            aware of any changes thereto. If we modify the Terms of Service, we will
                            make the relevant updates available through the Service. BLAGO will
                            endeavor to notify you of these changes by email, but will not be liable
                            for any failure to do so. Amendments will be effective upon BLAGO’s
                            posting of such updated terms. Continued use of the Service following
                            such posting shall indicate your acknowledgement of such changes and
                            agreement to be bound by the terms and conditions, as amended. If you do
                            not understand any of the terms herein, or have questions or other
                            issues related to your use of BLAGO, you may inquire regarding the same
                            via email at blagotruns@gmail.com.
                        </p> */}
                        <h2>16. GENERAL</h2>
                        <p>
                            <strong>
                                16.1. Dispute Resolution. PLEASE READ THIS CAREFULLY. IT AFFECTS
                                YOUR RIGHTS
                            </strong>
                        </p>
                        <p>
                            (a) Any and all controversies, disputes, demands, counts, claims, or
                            causes of action (including the interpretation and scope of this clause,
                            and the arbitrarily of the controversy, dispute, demand, count, claim,
                            or cause of action) between you and the BLAGO and our employees, agents,
                            successors, or assigns, regarding or relating to these the Service or
                            this Agreement, shall exclusively be settled through binding and
                            confidential arbitration.
                        </p>
                        <p>
                            You are thus GIVING UP YOUR RIGHT TO GO TO COURT to assert or defend
                            your rights. Your rights will be determined by a NEUTRAL ARBITRATOR and
                            NOT a judge or jury. You are entitled to a FAIR HEARING, BUT the
                            arbitration procedures are SIMPLER AND MORE LIMITED THAN RULES
                            APPLICABLE IN COURT. Arbitrator decisions are as enforceable as any
                            court order and are subject to VERY LIMITED REVIEW BY A COURT.
                        </p>
                        <p>
                            In the event of any dispute or claim arising out of or relating to this
                            Agreement, or a breach thereof, the Parties hereto shall consult and
                            negotiate with each other and, recognizing their mutual interests,
                            attempt to reach a satisfactory solution. If they do not reach
                            settlement within a period of 60 days, then, upon notice by any Party to
                            the other(s), any unresolved dispute or claim shall be settled by
                            arbitration in accordance with the UNCITRAL Arbitration Rules in effect
                            on the date of this contract.
                        </p>
                        <ul>
                            <li>
                                The appointing authority shall be the London Court of International
                                Arbitration.
                            </li>
                            <li>The number of arbitrators shall be one; </li>
                            <li>
                                The place of arbitration shall be London, England, and the governing
                                law of arbitration shall be the laws of England & Wales; 
                            </li>
                            <li>The language of the arbitration shall be English; and</li>
                            <li>
                                The arbitration will be conducted by video conferencing or other
                                suitable virtual electronic means and at mutually convenient times
                                such that participation of the parties’ representatives outside of
                                London may be allowed for.
                            </li>
                        </ul>
                        <p>
                            <strong>16.2. Force Majeure</strong>. Any delay in the performance of
                            any duties or obligations of either party (except the payment of money
                            owed) will not be considered a breach of this Agreement if such delay is
                            caused by a labor dispute, shortage of materials, fire, earthquake,
                            flood, or any other event beyond the control of such party.
                        </p>
                        <p>
                            <strong>16.3. Entire Agreement</strong>. This Agreement, including but
                            not limited to any applicable Accessorial Rates, SOP, and/or Work Order
                            incorporated by reference herein, constitutes the entire agreement
                            between you and us regarding the use of the Service. Our failure to
                            exercise or enforce any right or provision of this Agreement shall not
                            operate as a waiver of such right or provision. The section titles in
                            this Agreement are for convenience only and have no legal or contractual
                            effect. The word including means including without limitation. If any
                            provision of this Agreement is, for any reason, held to be invalid or
                            unenforceable, the other provisions of this Agreement will be unimpaired
                            and the invalid or unenforceable provision will be deemed modified so
                            that it is valid and enforceable to the maximum extent permitted by law.
                            This Agreement may be executed in counterparts.
                        </p>
                        <p>
                            <strong>16.4. Independent Contractor</strong>. Your relationship to
                            BLAGO is that of an independent contractor, and neither party is an
                            agent, employee or partner of the other. You assume complete
                            responsibility for all state and federal taxes, assessments, insurance
                            (including workers’ compensation, unemployment compensation, disability,
                            pension and social security insurance) and any other financial
                            obligations arising out of the transportation services rendered
                            hereunder. You are not, nor will you be deemed to be, an agent, legal
                            representative, joint venture, franchisor, franchisee, or legal partner
                            of BLAGO for any purpose. You will not be entitled to enter into any
                            contracts, make any representations or warranties in the name of, or
                            accept any obligations whatsoever on behalf of BLAGO.
                        </p>
                        <p>
                            <strong>16.5. Assignment</strong>. This Agreement, and your rights and
                            obligations herein, may not be assigned, subcontracted, delegated, or
                            otherwise transferred by you without BLAGO’s prior written consent, and
                            any attempted assignment, subcontract, delegation, or transfer in
                            violation of the foregoing will be null and void. The terms of this
                            Agreement shall be binding upon assignees.
                        </p>
                        <p>
                            <strong>16.6. Press</strong>. You hereby grant BLAGO permission to
                            identify you as a customer of BLAGO or user of our Services and to
                            reproduce your name and logo on the Site and in any other marketing
                            materials.
                        </p>
                        <p>
                            <strong>16.7. Conflict</strong>. If there is any conflict or
                            inconsistency between the terms and conditions set forth in this
                            Agreement and the terms set forth in any Bill of Lading, Proof of
                            Delivery or any other shipping form, the terms and conditions of this
                            Agreement shall control over such terms. If there is a conflict between
                            the terms of this Terms of Service and a separate agreement which serves
                            as the primary agreement for purposes of defining the transportation
                            services to be provided by BLAGO, the terms of such separate agreement
                            shall govern, but all non-conflicting terms herein shall apply. This
                            Agreement is construed in English with translation to Russian. In case
                            of discrepancies the English version shall prevail.
                        </p>
                        <p>
                            <strong>16.8. Electronic Communications</strong>. The communications
                            between you and BLAGO use electronic means, whether you use the Service
                            or send us emails, or whether BLAGO posts notices on the Service or
                            communicates with you via email. For contractual purposes, you (a)
                            consent to receive communications from BLAGO in an electronic form; and
                            (b) agree that all terms and conditions, agreements, notices,
                            disclosures, and other communications that BLAGO provides to you
                            electronically satisfy any legal requirement that such communications
                            would satisfy if it were be in a hardcopy writing. The foregoing does
                            not affect your non-waivable rights.
                        </p>
                        {/* <p>
                            <strong>16.9. Contact Information:</strong>
                        </p>
                        <p>BLAGO OÜ  Address: ______ Email: blagotruns@gmail.com</p> */}
                    </>
                ) : (
                    <>
                        <p>
                            Сайт www.blago.pro (далее – «Сайт») принадлежит компании BLAGO OÜ (далее
                            – <strong>«BLAGO», «мы»</strong>). BLAGO предоставляет сервис (
                            <strong>«Сервис»</strong>), который обеспечивает взаимодействие между
                            компаниями, осуществляющими автомобильные перевозки (
                            <strong>Перевозчики»</strong>), и компаниями, которым необходимо
                            перевезти груз (грузоотправители, грузополучателей или любые другие
                            лица, заинтересованные в перевозке груза) (
                            <strong>«Грузоотправитель»</strong>).
                        </p>
                        <p>
                            НАСТОЯЩИЕ УСЛОВИЯ ИСПОЛЬЗОВАНИЯ СЕРВИСА В АКТУАЛЬНОЙ РЕДАКЦИИ, С
                            ИЗМЕНЕНИЯМИ И ДОПОЛНЕНИЯМИ, КОТОРЫЕ МОГУТ БЫТЬ ВНЕСЕНЫ КОМПАНИЕЙ BLAGO В
                            ЛЮБОЕ ВРЕМЯ ПО ЕЕ УСМОТРЕНИЮ (ДАЛЕЕ – НАСТОЯЩЕЕ «СОГЛАШЕНИЕ»),
                            ПРЕДСТАВЛЯЮТ СОБОЙ ЮРИДИЧЕСКИ ОБЯЗЫВАЮЩИЕ УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ВАМИ
                            СЕРВИСА. ПОЛУЧАЯ ДОСТУП К СЕРВИСУ ИЛИ ИСПОЛЬЗУЯ ЕГО, ВЫ ПРИНИМАЕТЕ
                            УСЛОВИЯ НАСТОЯЩЕГО СОГЛАШЕНИЯ ОТ СВОЕГО ИМЕНИ ИЛИ ОТ ИМЕНИ КОМПАНИИ,
                            ОРГАНИЗАЦИИ ИЛИ ДРУГОГО ЮРИДИЧЕСКОГО ЛИЦА, ИНТЕРЕСЫ КОТОРОГО ВЫ
                            ПРЕДСТАВЛЯЕТЕ, И ЗАВЕРЯЕТЕ И ГАРАНТИРУЕТЕ, ЧТО ОБЛАДАЕТЕ ВСЕМИ
                            НЕОБХОДИМЫМИ ПОЛНОМОЧИЯМИ НА ЗАКЛЮЧЕНИЕ НАСТОЯЩЕГО СОГЛАШЕНИЯ ОТ СВОЕГО
                            ИМЕНИ ИЛИ ОТ ИМЕНИ КОМПАНИИ, ОРГАНИЗАЦИИ ИЛИ ДРУГОГО ЮРИДИЧЕСКОГО ЛИЦА,
                            ИНТЕРЕСЫ КОТОРОГО ВЫ ПРЕДСТАВЛЯЕТЕ. ЕСЛИ ВЫ МЛАДШЕ 18 ЛЕТ, ВЫ НЕ ВПРАВЕ
                            ОСУЩЕСТВЛЯТЬ ДОСТУП К СЕРВИСУ, ИСПОЛЬЗОВАТЬ ЕГО ИЛИ ПРИНИМАТЬ УСЛОВИЯ
                            НАСТОЯЩЕГО СОГЛАШЕНИЯ.
                        </p>
                        <p>
                            ВЫ МОЖЕТЕ ОСУЩЕСТВЛЯТЬ ДОСТУП К СЕРВИСУ ИЛИ ИСПОЛЬЗОВАТЬ ЕГО ТОЛЬКО В
                            ТОМ СЛУЧАЕ, ЕСЛИ ВЫ ПРИНИМАЕТЕ ВСЕ УСЛОВИЯ НАСТОЯЩЕГО СОГЛАШЕНИЯ.
                        </p>
                        <h2>1 ОПИСАНИЕ СЕРВИСА</h2>
                        <p>
                            <strong>1.1. Общие положения</strong>. BLAGO обеспечивает взаимодействие
                            между Грузоотправителями и Перевозчиками, которые заинтересованы в
                            грузоперевозке грузов, предоставляя платформу, на которой
                            Грузоотправители могут размещать сведения о запросах на грузоперевозку,
                            а Перевозчики – принимать такие запросы. «Пользователь» – любой
                            пользователь Сервиса. Пользователем может быть Перевозчик,
                            Грузоотправитель или представитель Перевозчика или Грузоотправителя.
                            Если вы являетесь Перевозчиком, к вам применяются положения настоящего
                            Соглашения, касающиеся Перевозчиков. Если вы являетесь
                            Грузоотправителем, к вам применяются положения настоящего Соглашения,
                            касающиеся Грузоотправителей. Если вы являетесь Пользователем, к вам
                            применяются положения настоящего Соглашения, касающиеся Пользователей.
                            Во избежание неоднозначного толкования настоящим уточняется, что
                            компания BLAGO лишь предоставляет платформу для размещения запросов на
                            Грузоперевозку и принятия таких запросов к исполнению, но не оказывает
                            услуги по перевозке.
                        </p>
                        <p>
                            <strong>1.2. Запросы на грузоперевозку</strong>. Перевозчик может
                            разместить запрос на грузоперевозку (далее – «Грузоперевозка») с помощью
                            Сервиса. Перевозчик указывает адрес отправления и назначения, определяет
                            дату и время получения груза, описание перевозимых предметов и любые
                            другие необходимые сведения о грузе. При этом BLAGO не несет
                            ответственности за условия осуществления Грузоперевозки. В результате
                            Грузоперевозка становится доступной для просмотра всем соответствующим
                            Перевозчикам. Грузоотправители вправе отменить Грузоперевозку в любое
                            время до ее принятия к исполнению Перевозчиком. Перевозчики могут в
                            любое время просмотреть список доступных Грузоперевозок и принять
                            Грузоперевозку к исполнению с помощью Сервиса. Грузоперевозка
                            закрепляется за Перевозчиком, который первым принял ее к исполнению.
                            После принятия Грузоперевозки к исполнению Перевозчиком BLAGO уведомляет
                            Грузоотправителя об этом. BLAGO не гарантирует, что на выполнение
                            какой-либо конкретной Грузоперевозки будет получено согласие
                            Перевозчика. Если ни один из Перевозчиков не примет к исполнению
                            Грузоперевозку, BLAGO уведомит Грузоотправителя об этом.
                        </p>
                        <h2>УСЛОВИЯ, ЗАВЕРЕНИЯ И ГАРАНТИИ ПЕРЕВОЗЧИКА</h2>
                        <p>
                            <strong>2.1. Минимальные требования к Перевозчику</strong>. В качестве
                            Перевозчика настоящим вы заявляете и гарантируете, что:
                        </p>
                        <ul>
                            <li>
                                (a) Вы обладаете всеми необходимыми разрешениями на оказание услуг
                                по Грузоперевозке в качестве перевозчика товаров и/или грузов на
                                договорных условиях и готовы оказывать услуги по Грузоперевозке.
                            </li>
                            <li>
                                (b) Вы имеете и будете иметь в течение всего времени выполнения
                                Грузоперевозок с помощью Сервиса все необходимые разрешения и
                                полномочия, необходимые в соответствии с применимым
                                законодательством для оказания подобных услуг по Грузоперевозке по
                                настоящему Соглашению.
                            </li>
                            <li>
                                (с) Все используемое вами оборудование полностью соответствует
                                применимым нормам и требованиям законодательства.
                            </li>
                        </ul>
                        <p>
                            <strong>2.2. Оборудование</strong>. В отношении оборудования, которое вы
                            используете для оказания услуг Грузоперевозки в соответствии с
                            настоящими Условиями использования Сервиса, настоящим вы заявляете и
                            гарантируете, что:
                        </p>
                        <ul>
                            <li>
                                (a) Вы обязуетесь предоставить за свой счет все оборудование,
                                необходимое для оказания услуг Грузоперевозки в соответствии с
                                настоящими Условиями использования Сервиса, и оплатить все расходы,
                                связанные с использованием, эксплуатацией и обслуживанием такого
                                оборудования (включая любые штрафы, пени и сборы).
                            </li>
                            <li>
                                (b) Вы обязуетесь предоставить оборудование, которое соответствует
                                всем применимым государственным нормативным стандартам и
                                требованиям, прошло все необходимые испытания, имеет все необходимые
                                лицензии, правоустанавливающие документы, разрешения и
                                регистрационные удостоверения, обладает требуемым качеством и
                                предоставляется в количестве, необходимом для выполнения каждой
                                Грузоперевозки, которую вы соглашаетесь выполнить.
                            </li>
                        </ul>
                        <p>
                            <strong>2.3. Сотрудники и услуги</strong>. В отношении ваших
                            сотрудников, оказывающих услуги Грузоперевозки в соответствии с
                            настоящими Условиями использования Сервиса, настоящим вы заявляете и
                            гарантируете, что:
                        </p>
                        <ul>
                            <li>
                                (a) Вы обязуетесь нанимать персонал, необходимый для оказания услуг
                                Грузоперевозки, и несете личную ответственность за весь такой
                                персонал.
                            </li>
                            <li>
                                (b) Вы несете личную ответственность за любые действия и бездействие
                                ваших водителей, а также за соблюдение такими водителями всего
                                применимого законодательства и регламентов.
                            </li>
                            <li>
                                (c) Вы несете личную ответственность за проведение собеседований,
                                прием на работу, обучение, наложение дисциплинарных взысканий и
                                увольнение ваших водителей и других сотрудников.
                            </li>
                            <li>
                                (d) Вы будете привлекать к оказанию услуг только таких водителей и
                                другой обслуживающий персонал, которые имеют лицензию на оказание
                                соответствующих услуг.
                            </li>
                        </ul>
                        <p>
                            <strong>2.4. Инструкции Грузоотправителя</strong>. В случае
                            предоставления Грузоотправителем конкретных инструкций о надлежащей
                            погрузке, обработке и отправке груза, такие условия имеют
                            преимущественную юридическую силу, и вы, будучи Перевозчиком, обязаны
                            соблюдать их.
                        </p>
                        <p>
                            <strong>2.5. Принятие ответственности</strong>. В качестве Перевозчика
                            настоящим Вы заявляете и гарантируете, что:
                        </p>

                        <p>
                            (а) Вы несете единоличную ответственность по всем обязательствам,
                            возникающим в результате оказания вами услуг в соответствии с настоящим
                            Соглашением, включая, в том числе, материальный ущерб, утрату груза,
                            повреждение или задержку, причинение вреда здоровью и смерти (в том
                            числе обязательства, относящиеся к вашему имуществу и вашим
                            сотрудникам). Во всех случаях вы несете ответственность как организация
                            автомобильных перевозок. Ваша ответственность заключается в возмещении
                            полной сумме любых таких убытков, ущерба, стоимости или других
                            обязательств, вне зависимости от ограничений вашей страховой
                            ответственности.
                        </p>
                        <p>
                            (b) Вы обязуетесь освобождать от ответственности, обеспечивать правовую
                            защиту и (или) возмещать ущерб BLAGO, Грузоотправителей и
                            грузополучателей (и их должностных лиц, сотрудников и агентов) (далее
                            совместно – «Освобожденные от ответственности лица на стороне
                            Грузоотправителя») в отношении любых претензий, требований, убытков,
                            ущерба и расходов (включая издержки и вознаграждение адвокатов) или
                            обязательств (далее совместно – «Требования»), возникающих в связи с
                            совершением вами, вашими водителями или другими агентами следующих
                            действий: (i) использование Сервиса; (ii) использование
                            Пользовательского контента или осуществление доступа к нему; (iii)
                            взаимодействие с любым другим Пользователем; (iv) нарушение любого из
                            условий настоящего Соглашения; (v) требования к заработной плате
                            водителей, сверхурочной работе и перерывам на питание / отдых, фонды
                            заработной платы и другие налоги, удерживаемые у источника дохода,
                            страхование от безработицы, пенсии, компенсации работникам, социальное
                            обеспечение и сопутствующие меры защиты, а также любые расходы на
                            оборудование и топливо; (vi) нарушение применимого законодательства; или
                            (vii) оказание транспортных услуг с помощью Сервиса. Вышеуказанные
                            обязательства не распространяются на освобождение какого-либо
                            конкретного Грузоотправителя от ответственности, если суд
                            соответствующей юрисдикции определит, что такой Грузоотправитель несет
                            ответственность за удовлетворение Требований. Данное возмещение убытков
                            применяется вне зависимости от положений договоров, заключенных между
                            компанией BLAGO и третьими лицами. Настоящим вы также отказываетесь от
                            любых претензий или требований к Освобожденным от ответственности лицам
                            на стороне Грузоотправителя в связи с любыми убытками, расходами,
                            затратами или обязательствами, возникающими в результате совершения вами
                            или вашими агентами вышеуказанных действий.
                        </p>
                        <p>
                            (c) помимо вышеуказанных гарантий и заявлений, вы обязуетесь освобождать
                            от ответственности, обеспечивать правовую защиту и (или) возмещать ущерб
                            Освобожденным от ответственности лицам на стороне Грузоотправителя в
                            отношении Требований, возникающих в связи с совершением вами, вашими
                            водителями или другими агентами следующих действий:
                        </p>
                        <p>
                            "(i).Отказ своевременной погрузки груза, по согласованным перевозкам, в
                            пункте отправки при наличии возможности такой погрузки, отказ прибытия в
                            пункт отправки для получения груза по согласованной перевозке, а равно
                            отказ исполнения принятых обязательств по своевременной и надежной
                            доставке в пункт назначения при наличии возможности добросовестного
                            исполнения принятых на себя обязательств.
                        </p>

                        <p>
                            (ii) Ненадлежащая или небезопасная погрузка или разгрузка груза или,
                            если вы не несете обязанности по погрузке, неисполнение обязанности по
                            надлежащей проверке погрузки и размещения товара, в той степени, в
                            которой это может быть сделано посредством проведения обычного осмотра.
                        </p>
                        <p>
                            (iii) Перевозка каких-либо грузов с нарушением применимого веса или оси,
                            применимого законодательства или инструкций Грузоотправителя.
                        </p>
                        <p>
                            (iv) Приостановление оказания услуг в любое время после отправки груза
                            или задержка оказания услуг в связи с остановкой по любой причине, в
                            результате чего ваше оборудование и груз останутся без присмотра и без
                            надлежащей защиты, которую бы обеспечил при должной осмотрительности
                            Перевозчик или которая иным образом требуется в соответствии с вашими
                            полисами страхования.
                        </p>
                        <p>
                            (v) Приемка каких-либо партий грузов, в отношении которых вы не можете
                            соблюдать применимый температурный режим, и причинение какого-либо
                            ущерба вследствие несоблюдения такого режима.
                        </p>
                        <p>
                            (vi) Использование оборудования, которое ранее использовалось для
                            транспортировки каких-либо отходов, мусора или товаров, перевозка
                            которых приводит к загрязнению других партий грузов.
                        </p>
                        <p>
                            (vii) Неисполнение обязанности по проверке наличия опасные вещества в
                            партии груза, приемка опасных веществ и нарушение применимого
                            законодательства о транспортировке опасных веществ.
                        </p>
                        <p>
                            (viii) Отсоединение Вашей силовой установки от автофургона, контейнера /
                            шасси, автомобиля с безбортовой платформой или другого оборудования в
                            любое время, если это не вызвано чрезвычайными или исключительными
                            обстоятельствами.
                        </p>
                        <p>
                            (ix) Оказание услуг, предусмотренных настоящим Соглашением, надлежащего
                            качества, не профессионально и в противоречие стандартам торговли.
                        </p>
                        <p>
                            (x) Использование оборудования, которое является технически не исправным
                            и не безопасно в эксплуатации, имеет загрязнения, содержит насекомых,
                            грызунов, запахи и плесень, не защищено герметично от воды и (или)
                            влаги, не безопасно, ненадлежащим образом обслуживается и представляет
                            опасность.
                        </p>
                        <p>
                            (d) BLAGO сохраняет за собой право принять на себя, за ваш счет,
                            исключительную правовую защиту и контроль по любому вопросу, по которому
                            вы обязаны возместить нам ущерб. При этом вы обязуетесь оказывать нам
                            содействие при осуществлении нами правовой защиты по таким требованиям.
                            Вы обязуетесь не заключать мировое соглашение по каким бы то ни было
                            вопросам без получения письменного согласия BLAGO. Компания BLAGO будет
                            прилагать надлежащие усилия для уведомления вас о любых таких
                            требованиях, исках или судебных разбирательствах, о которых ей станет
                            известно.
                        </p>
                        <h2>УСЛОВИЯ, ЗАВЕРЕНИЯ И ГАРАНТИИ ГРУЗООТПРАВИТЕЛЯ</h2>
                        <p>
                            <strong>3.1. Заверения и гарантии</strong>. Если вы являетесь
                            Грузоотправителем, настоящим вы заявляете и гарантируете, что:
                        </p>
                        <p>
                            (a) Вы распоряжаетесь отгруженными товарами или имеете необходимые права
                            на их перевозку, а также обладаете полномочиями накладывать на владельца
                            товара обязательства по соблюдению положений настоящего Соглашения.
                        </p>
                        <p>
                            (b) Вы используете Сервис для перевозки товаров под свою ответственность
                            с привлечением компаний автомобильных перевозок, использующих Сервис; за
                            некоторыми исключениями, прямо предусмотренными настоящим Соглашением,
                            вы соглашаетесь с тем, что BLAGO не несет ответственности за отгруженные
                            товары или какие-либо обязательства по любым требованиям, претензиям,
                            убыткам или ущербу в связи с такими товарами.
                        </p>
                        <p>
                            (c) Вы несете единоличную ответственность по всем обязательствам,
                            возникающим в связи с такими отгруженными товарами, включая, в том
                            числе, причинение вреда имуществу или здоровью и смерть.
                        </p>
                        <p>
                            (d) Если вы осуществляете погрузку, крепление и обеспечение безопасности
                            ваших товаров, вы понимаете, что несете ответственность в отношении
                            любых требований, убытков или ущерба, возникших в результате ваших
                            ненадлежащих или небезопасных действий. Вы понимаете, что BLAGO не несет
                            ответственности за обеспечение безопасности, погрузку, упаковку Ваших
                            товаров или за соблюдение инструкций по их отгрузке.
                        </p>
                        <p>
                            (e) Вы принимаете к сведению, что BLAGO не является компанией
                            автомобильных перевозок, следовательно, не несет ответственности перед
                            вами или получателем груза за любой груз, отправленный в соответствии с
                            настоящим Соглашением.
                        </p>
                        <p>
                            (f) Вы понимаете, что отслеживание местоположения ваших партий груза с
                            помощью Сервиса не гарантирует, что такие партии груза будут доставлены
                            вам в указанное время.
                        </p>
                        <p>
                            <strong>3.3. Запрещенные предметы</strong>. Грузоотправители не должны
                            использовать Сервис для перевозки нижеуказанных предметов и соглашаются
                            с тем, что Переводчик и BLAGO не несут никакой ответственности за утрату
                            или повреждение любого из следующих предметов:
                        </p>
                        <p>
                            (а) предметы контрабанды или нелегальные, опасные, радиоактивные,
                            вредные, небезопасные, оскорбительные или нежелательные предметы;
                        </p>
                        <p>
                            (b) слитки, драгоценные металлы, изделия из драгоценных металлов,
                            золото, серебро, платина, драгоценные или полудрагоценные камни
                            (включая, в том числе, алмазы, изумруды, сапфиры и рубины) и ювелирные
                            изделия из драгоценных металлов и драгоценных камней;
                        </p>
                        <p>
                            (c) деньги, ценные бумаги, счета, векселя, валюта, талоны на питание,
                            лотерейные билеты, векселя, банкноты, монеты, облигации, оборотные
                            инструменты или долговые документы, паспорта, билеты, документы,
                            рукописи, записи или другие ценные документы;
                        </p>
                        <p>(d) табачные изделия и обработанный табак;</p>
                        <p>(е) бутилированные спиртные напитки;</p>
                        <p>
                            (f) ценные произведения искусства, в том числе антиквариат, картины,
                            скульптуры, гобелены, предметы коллекционирования или другие экспонаты;
                            или
                        </p>
                        <p>
                            (h) домашний скот и живой скот, включая крупный рогатый скот и домашнюю
                            птицу.
                        </p>
                        <p>
                            <strong>3.4. Возмещение убытков Грузоотправителя</strong>. Вы обязуетесь
                            освобождать от ответственности, обеспечивать правовую защиту и (или)
                            возмещать ущерб компании BLAGO (и ее должностным лицам, сотрудникам и
                            агентам) (далее по отдельности именуемых «Освобожденное от
                            ответственности лицо на стороне Перевозчика») в отношении любых
                            Претензий, возникающих в связи с совершением вами или вашими агентами
                            следующих действий: (а) использование Сервиса; (b) использование
                            Пользовательского контента или осуществление доступа к нему; (c)
                            взаимодействие с любым другим Пользователем; (d) нарушение условий
                            настоящего Соглашения; (e) нарушение применимого законодательства; или в
                            связи с (f) содержимым вашей грузоперевозки. BLAGO сохраняет за собой
                            право принять на себя, за ваш счет, исключительную правовую защиту и
                            контроль в отношении любого вопроса, по которому вы обязаны возместить
                            нам ущерб. При этом вы обязуетесь оказывать нам содействие при
                            осуществлении нами правовой защиты по таким требованиям. Вышеуказанные
                            обязательства не применяются, если суд соответствующей юрисдикции
                            определит, что какое-либо Требование связано с небрежностью или
                            умышленным неправомерным поведением компании BLAGO. Вы обязуетесь не
                            заключать мировое соглашение по каким бы то ни было вопросам без
                            получения письменного согласия BLAGO. Компания BLAGO будет прилагать
                            надлежащие усилия для уведомления вас о любых таких требованиях, исках
                            или судебных разбирательствах, о которых ей станет известно. Указанное
                            возмещение убытков в отношении BLAGO применяется вне зависимости от
                            положений договоров, заключенных между компанией BLAGO и третьими
                            лицами. Настоящим Вы также отказываетесь от любых претензий или
                            требований по отношению к компании BLAGO в связи с любыми убытками,
                            расходами, затратами или обязательствами, возникающими в результате
                            совершения вами или вашими агентами вышеуказанных действий.
                        </p>
                        <h2>ТРЕБОВАНИЯ В СВЯЗИ С ГРУЗОМ</h2>
                        <p>
                            <strong>4.1. Ответственность Перевозчика</strong>. (а) Перевозчик
                            обязуется принять на себя полную ответственность за своевременную и
                            безопасную транспортировку всех партий груза по настоящему Соглашению.
                            Ответственность Перевозчика перед BLAGO, Грузоотправителем и (или) любым
                            привлеченным грузоотправителем или грузополучателем составляет стоимость
                            перевозимых товаров по счету-фактуре, без каких-либо ограничений.
                        </p>
                        <p>
                            <strong>4.2. Ограничение ответственности BLAGO</strong>.
                            Грузоотправитель принимает к сведению и подтверждает, что Перевозчик
                            несет основную ответственность за утрату и повреждение груза, а BLAGO не
                            несет ответственности за действия или бездействие Перевозчика. За
                            исключением случаев, когда отдельным письменным договором с клиентом,
                            подписанным должностными лицами BLAGO и такого клиента, предусмотрено
                            иное, исключительная ответственность BLAGO в отношении утраты или
                            повреждения груза, в том числе вследствие необоснованной задержки,
                            определяется степенью, в которой такая утрата или такое повреждение:
                            вызвано небрежностью или умышленным неправомерным поведением BLAGO.
                            Ответственность BLAGO за такую утрату или такое повреждение груза ни при
                            каких обстоятельствах не может превышать меньшую из следующих сумм: (i)
                            затраты на ремонт или замену соответствующих товаров; (ii) 0,1 долл. США
                            за фунт за упаковку; и (iii) 500 долл. США по каждому случаю.
                            Исключительная ответственность BLAGO и единственное возмещение
                            Грузоотправителем или владельцем с BLAGO ущерба в связи утратой,
                            повреждением груза или задержкой должны соответствовать положениям
                            данного пункта. Кроме того, BLAGO ни при каких обстоятельствах не несет
                            ответственности за действия или бездействие каких-либо третьих лиц,
                            включая любых Перевозчиков, в том числе за отказ Перевозчика от
                            удовлетворения обоснованного требования или несоблюдение инструкций
                            Грузоотправителя.
                        </p>
                        <p>
                            <strong>4.3. Предъявление и урегулирование требований</strong>. (a) В
                            случае утраты или повреждения груза, Грузоотправитель или любой
                            грузоотправитель или грузополучатель должен стремиться предъявить
                            требование Перевозчику в течение 90 (девяноста) дней с момента
                            происшествия, но в любом случае не позднее, чем через 6 (шесть) месяцев
                            с момента происшествия. Если иное не согласовано в отдельном письменном
                            договоре, Грузоотправитель не вправе производить зачет сумм неоплаченных
                            или неурегулированных требований в счет сумм, которые Грузоотправитель
                            должен уплатить компании BLAGO. Грузоотправитель не должен предъявлять
                            требования в связи с утратой или повреждением груза, а BLAGO и
                            Перевозчик не несут ответственности за утрату или повреждение груза в
                            случае отсутствия убедительного подтверждения такой утраты или такого
                            повреждения.
                        </p>
                        <p>
                            (b) Перевозчики должны урегулировать требования в течение 60
                            (шестидесяти) дней с момента получения ими требований со всей
                            необходимой документацией.
                        </p>
                        <h2>УСЛОВИЯ ОПЛАТЫ</h2>
                        <p>
                            <strong>5.1. Платежи и сборы Грузоотправителя</strong>.
                        </p>
                        <p>
                            (a) Грузоотправитель обязан уплачивать сборы за любые Грузоперевозки
                            непосредственно Перевозчику (далее – «Сбор за Грузоперевозку»).
                        </p>
                        <h2>ЛИЦЕНЗИИ</h2>
                        <p>
                            <strong>6.1. Учетные записи</strong>. Для того, чтобы иметь возможность
                            использования определенных функциональных возможностей Сервиса, вы
                            должны зарегистрировать учетную запись в BLAGO (далее – «Учетная
                            запись») и предоставить определенную информацию, запрашиваемую в
                            регистрационной форме. Вы заявляете и гарантируете, что: (a) вся
                            необходимая регистрационная информация, которую вы отправляете, является
                            достоверной и точной; и (b) вы будете обеспечивать актуальность такой
                            информации. Вы вправе удалить свою Учетную запись в любое время и на
                            любых основаниях, следуя инструкциям Сервиса. Вы несете ответственность
                            за соблюдение конфиденциальности реквизитов доступа к своей Учетной
                            записи и за все действия, которые осуществляются в вашей Учетной записи.
                            Каждая Учетная запись может использоваться для доступа к Сервису только
                            в течение одного единовременного сеанса входа в систему. Вы обязуетесь
                            незамедлительно уведомлять BLAGO о любом несанкционированном
                            использовании или подозрении на несанкционированное использование вашей
                            Учетной записи, а также о любом другом нарушении безопасности. BLAGO не
                            несет ответственности за какие бы то ни было убытки или ущерб, возникшие
                            в результате несоблюдения вами вышеуказанных требований.
                        </p>
                        <p>
                            <strong>6.2. Сайт</strong>. В соответствии с условиями настоящего
                            Соглашения BLAGO предоставляет вам не подлежащую передаче
                            неисключительную лицензию на использование Сайта для целей вашей
                            коммерческой деятельности в течение срока действия настоящего
                            Соглашения.
                        </p>
                        <p>
                            <strong>6.3. Определенные ограничения</strong>. На права,
                            предоставленные вам по настоящему Соглашению, распространяются следующие
                            ограничения: (а) вы не имеете права предоставлять лицензию, продавать,
                            сдавать в аренду или лизинг, передавать, производить переуступку,
                            распространять, размещать или иным образом использовать Сервис в
                            коммерческих целях; (b) вы не должны изменять какой-либо компонент
                            Сервиса, создавать производные работы, демонтировать, декомпилировать
                            или осуществлять обратное проектирование какой-либо части Сервиса; (c)
                            вы не должны осуществлять доступ к Сервису в целях создания аналогичного
                            или конкурирующего сервиса; и (d) за исключением случаев, прямо
                            предусмотренных настоящим Соглашением, не разрешается копировать,
                            воспроизводить, распространять, переиздавать, загружать, отображать,
                            размещать или передавать какой-либо компонент Сервиса, в любой форме и
                            любыми средствами. На любые будущие версии, обновления или другие
                            дополнения к функциональным характеристикам Сервиса будут
                            распространяться условия настоящего Соглашения. Все уведомления об
                            авторских правах и прочие уведомления правообладателя в отношении любого
                            контента Сервиса должны быть сохранены на всех его копиях.
                        </p>
                        <p>
                            <strong>6.4. Ограниченная поддержка</strong>. Пользователи вправе
                            обращаться в центр технической поддержки BLAGO по любым вопросам
                            поддержки, возникающим в результате использования Сервиса, следуя
                            инструкциям Сервиса.
                        </p>
                        <h2>ПРАВО СОБСТВЕННОСТИ</h2>
                        <p>
                            <strong>7.1. Право собственности</strong>. За исключением вашего
                            Пользовательского контента (см. определение ниже), вы подтверждаете, что
                            все права интеллектуальной собственности на Сервис, включая авторские
                            права, патенты, товарные знаки и сведения, составляющие коммерческую
                            тайну, принадлежат BLAGO или лицензиарам BLAGO. Предоставление Сервиса
                            не передает вам или каким-либо третьим лицам никаких имущественных или
                            иных прав на такие права интеллектуальной собственности. Компания BLAGO
                            и ее поставщики сохраняют за собой все права, не предоставленные по
                            настоящему Соглашению.
                        </p>
                        <p>
                            <strong>7.2. Изменение</strong>. BLAGO сохраняет за собой право в любое
                            время изменить, приостановить или прекратить предоставление Сервиса или
                            любого его компоненты, с предоставлением уведомления или без него. Вы
                            соглашаетесь с тем, что BLAGO не несет ответственности перед вами или
                            какими бы то ни было третьими лицами за изменения, приостановку или
                            прекращение предоставления Сервиса или любого его компонента.
                        </p>
                        <p>
                            <strong>7.3. Обратная связь</strong>. Если вы отправляете BLAGO
                            какую-либо обратную связь, предложения, отчеты об ошибках, системные
                            ошибки и другие сведения или концепции, касающиеся Сервиса (далее –
                            «Обратная связь»), тем самым вы передаете BLAGO все права на Обратную
                            связь и соглашаетесь с тем, что компания BLAGO вправе использовать такую
                            Обратную связь и соответствующие сведения любым способом, который она
                            сочтет целесообразным. Без ограничения общего смысла вышеизложенного,
                            данная переуступка прав распространяется на любые отзывы,
                            предоставленные вами; настоящим вы также предоставляете BLAGO право на
                            использование вашего имени в связи с доведением таких отзывов до
                            сведения общественности. BLAGO будет рассматривать любую Обратную связь,
                            предоставленную вами, как не являющуюся конфиденциальной и не защищенную
                            правами собственности. Вы соглашаетесь с тем, что не будете
                            предоставлять BLAGO какие-либо сведения или концепции, которые вы
                            считаете конфиденциальными или защищенными правами собственности.
                            Соглашаясь принять участие в каких-либо тематических исследованиях, вы
                            соглашаетесь с тем, что информация, предоставленная вами в связи с
                            такими исследованиями, считается Обратной связью и что BLAGO вправе
                            использовать ваше имя в связи с предоставлением такой Обратной связи.
                        </p>
                        <h2>ПОЛЬЗОВАТЕЛЬСКИЙ КОНТЕНТ</h2>
                        <p>
                            <strong>8.1. Пользовательский контент</strong>. «Пользовательский
                            контент» – любая информация, данные и другой контент, который
                            Пользователь предоставляет в Сервис или использует совместно с Сервисом.
                            Пользовательский контент включает информацию, предоставленную в запросе
                            на Грузоперевозку или в согласии на выполнение такого запроса. Вы несете
                            единоличную ответственность за свой Пользовательский контент. Вы
                            принимаете на себя все риски, связанные с использованием вашего
                            Пользовательского контента, включая то, что другие лица полагаются на
                            его точность, полноту или практическую значимость, а также с раскрытием
                            вашего Пользовательского контента, которое позволяет идентифицировать
                            вас или какое-либо третье лицо. Настоящим вы заявляете и гарантируете,
                            что ваш Пользовательский контент не нарушает Политику допустимого
                            использования (см. определение ниже). Во избежание неоднозначного
                            толкования настоящим уточняется, что Пользовательский контент, который
                            вы предоставляете, может содержать контент третьих лиц. Вы обязуетесь
                            предоставлять контент третьих лиц только в случае получения согласия от
                            соответствующего владельца такого контента, являющегося третьим лицом.
                            Вы не вправе заявлять или предполагать, что ваш Пользовательский контент
                            предоставлен, финансируется или одобрен BLAGO каким-либо образом. В силу
                            того, что вы (а не BLAGO) несете ответственность за ваш Пользовательский
                            контент, вы можете быть привлечены к ответственности, если, например,
                            ваш Пользовательский контент нарушает Политику допустимого
                            использования. В силу того, что мы не осуществляем контроль за
                            Пользовательским контентом, вы признаете и подтверждаете, что мы не
                            несем ответственности за какой бы то ни было Пользовательский контент и
                            не предоставляем гарантий в отношении его достоверности, актуальности,
                            практической значимости или качества.
                        </p>
                        <p>
                            <strong>8.2. Лицензия</strong>. Настоящим Вы предоставляете BLAGO (а
                            также заявляете и гарантируете, что имеете право предоставить)
                            безотзывную, неисключительную, не предусматривающую авторские выплаты,
                            полностью оплаченную лицензию с правом сублицензирования, действующую в
                            любой стране мира, на использование вашего Пользовательского контента в
                            целях включения вашего Пользовательского контента в Сервис для создания
                            Обезличенных данных в соответствии с Политикой конфиденциальности BLAGO
                            (далее – «Политика конфиденциальности»). Вы сохраняете все права на
                            Пользовательский контент, не предоставленные BLAGO по настоящему
                            Соглашению или в соответствии с Политикой конфиденциальности.
                        </p>
                        <h2>ПОЛИТИКА ДОПУСТИМОГО ИСПОЛЬЗОВАНИЯ</h2>
                        <p>Ниже приведена Политика допустимого использования компании BLAGO:</p>
                        <p>
                            <strong>9.1</strong>. Вы обязуетесь не использовать Сервис для сбора,
                            загрузки, передачи, отображения или распространения какого-либо
                            Пользовательского контента, который: (а) нарушает какие-либо права
                            третьих лиц, включая авторские права, товарные знаки, патенты,
                            коммерческую тайну, личные неимущественные права, право на
                            неприкосновенность частной жизни, право на публичное использование или
                            любые другие права на интеллектуальную собственность или имущественные
                            права; (b) является незаконным, причиняющим беспокойство,
                            оскорбительным, вредоносным, угрожающим, вредным, посягающим на частную
                            жизнь другого лица, вульгарным, дискредитирующим, ложным, умышленно
                            вводящим в заблуждение, клеветническим, порнографическим, непристойным,
                            явно оскорбительным (например, материалы, пропагандирующие расизм,
                            фанатизм, ненависть или причинение вреда здоровью в отношении какой-либо
                            группы лиц или отдельного лица) или иным образом представляет собой
                            материалы сомнительного содержания или материалы, которые могут
                            причинить какой-либо вред несовершеннолетним; или (c) нарушает
                            какие-либо законы, другие нормативно-правовые акты, обязательства или
                            ограничения, введенные каким-либо третьим лицом.
                        </p>
                        <p>
                            <strong>9.2</strong>. Кроме этого, вы обязуетесь не использовать Сервис
                            для: (а) загрузки, передачи или распространения каких-либо компьютерных
                            вирусов, червей или программного обеспечения, предназначенного для
                            повреждения или изменения компьютерной системы или данных; (b) рассылки
                            нежелательных или несанкционированных рекламных объявлений, рекламных
                            материалов, нежелательной почты, спама, писем, рассылаемых по цепочке,
                            материалов о финансовых пирамидах, любых других дублирующих или
                            несогласованных с получателем сообщений, коммерческого или иного
                            характера; (c) сбора информации или данных о других Пользователях,
                            включая адреса электронной почты, без их согласия; (d) вмешательства в
                            работу серверов или сетей, подключенных к Сервису, и создания чрезмерной
                            нагрузки на них, нарушения правил, политик или процедур таких сетей; (e)
                            совершения попыток получения несанкционированного доступа к Сервису,
                            другим компьютерным системам или сетям, подключенным к Сервису или
                            используемым совместно с ним, путем подбора пароля или другим способом;
                            (f) вмешательства в использование Сервиса другими Пользователями; или
                            (g) внедрения программного обеспечения, автоматизированных Агентов или
                            скриптов в Сервис для создания множественных учетных записей,
                            осуществления автоматизированного поиска, направления запросов или
                            извлечения данных из Сервиса.
                        </p>
                        <p>
                            Мы сохраняем за собой право (но не обязаны) просматривать любой
                            Пользовательский контент, проводить расследование и (или) принимать
                            соответствующие меры в отношении вас по собственному усмотрению (включая
                            удаление или изменение вашего Пользовательского контента, прекращение
                            действия вашей Учетной записи в соответствии со разделом 10 настоящего
                            Соглашения и (или) предоставление информации о ваших действиях в
                            правоохранительные органы) в случаях, если вы нарушаете Политику
                            допустимого использования или какое-либо другое положение настоящего
                            Соглашения или иным образом навлекаете ответственность на нас или
                            какое-либо другое лицо.
                        </p>
                        <h2>СРОК ДЕЙСТВИЯ И РАСТОРЖЕНИЕ</h2>
                        <p>
                            <strong>10.1</strong>. В соответствии с положениями данного раздела
                            настоящее Соглашение будет сохранять юридическую силу и действовать в
                            полном объеме во время использования вами Сервиса. BLAGO вправе в любое
                            время расторгнуть настоящее Соглашение с вами по собственному
                            усмотрению, если: (а) вы нарушили какое-либо положение настоящего
                            Соглашения, применимой Стандартной операционной процедуры или Заявки на
                            выполнение работ (или действовали так, что становится очевидным, что вы
                            не собираетесь или не можете соблюдать настоящее Соглашение); (b) BLAGO
                            обязана сделать это в соответствии с законодательно установленными
                            требованиями (например, если предоставление вам Сервиса является или
                            становится незаконным); или (c) BLAGO решила прекратить предоставление
                            Сервиса, как описано в пункте 7.2. После расторжения настоящего
                            Соглашения ваша Учетная запись будет немедленно удалена, а право доступа
                            к Сервису и его использование будет утрачено. BLAGO не несет перед вами
                            никакой ответственности за прекращение возможности использования
                            Сервиса, в том числе за удаление вашей Учетной записи или вашего
                            Пользовательского контента. Следующие положения настоящего Соглашения
                            остаются в силе после его расторжения: пункт 6.4, разделы 7-16
                            включительно.
                        </p>
                        <h2>ОТКАЗ ОТ ГАРАНТИЙ И ОСВОБОЖДЕНИЕ ОТ ОТВЕТСТВЕННОСТИ</h2>
                        <p>
                            <strong>11.1</strong>. СЕРВИС ПРЕДОСТАВЛЯЕТСЯ НА УСЛОВИЯХ «КАК ЕСТЬ». МЫ
                            (И НАШИ ПОСТАВЩИКИ) НЕ ДАЕМ НИКАКИХ ПРЯМЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ ГАРАНТИЙ,
                            ВКЛЮЧАЯ ГАРАНТИИ ИЛИ УСЛОВИЯ, БЕСПРЕПЯТСТВЕННОГО ИСПОЛЬЗОВАНИЯ,
                            ДОСТОВЕРНОСТИ ИЛИ ОТСУТСТВИЯ НАРУШЕНИЯ КАКИХ-ЛИБО ПРАВ. МЫ (И НАШИ
                            ПОСТАВЩИКИ) НЕ ПРЕДОСТАВЛЯЕМ НИКАКИХ ГАРАНТИЙ ТОГО, ЧТО СЕРВИС: (A)
                            БУДЕТ СООТВЕТСТВОВАТЬ ВАШИМ ТРЕБОВАНИЯМ ИЛИ ОЖИДАНИЯМ; (B) БУДЕТ
                            ДОСТУПЕН БЕСПЕРЕБОЙНЫМ, СВОЕВРЕМЕННЫМ И БЕЗОПАСНЫМ ОБРАЗОМ ИЛИ НЕ БУДЕТ
                            СОДЕРЖАТЬ ОШИБОК; (C) БУДЕТ ТОЧНЫМ, НАДЕЖНЫМ, НЕ БУДЕТ СОДЕРЖАТЬ ВИРУСОВ
                            ИЛИ КАКИХ-ЛИБО ДРУГИХ ВРЕДОНОСНЫХ КОДОВ, БУДЕТ ПОЛНЫМ, ЗАКОННЫМ ИЛИ
                            БЕЗОПАСНЫМ; ИЛИ (D) МОЖЕТ ИСПОЛЬЗОВАТЬСЯ ДЛЯ ПОЛУЧЕНИЯ ПРИБЫЛИ, ДОХОДА
                            ИЛИ СНИЖЕНИЯ ИЗДЕРЖЕК. ИСПОЛЬЗОВАНИЕ СЕРВИСА МОЖЕТ БЫТЬ ОБУСЛОВЛЕНО
                            ОГРАНИЧЕНИЯМИ. ТАКЖЕ ПРИ ИСПОЛЬЗОВАНИИ СЕРВИСА МОГУТ ВОЗНИКАТЬ ЗАДЕРЖКИ
                            И ДРУГИЕ ПРОБЛЕМЫ, СВЯЗАННЫЕ С ИСПОЛЬЗОВАНИЕМ СЕТИ ИНТЕРНЕТ И
                            ЭЛЕКТРОННЫХ СРЕДСТВ СВЯЗИ. МЫ НЕ НЕСЕМ ОТВЕТСТВЕННОСТИ ЗА КАКИЕ-ЛИБО
                            ЗАДЕРЖКИ, НЕВОЗМОЖНОСТЬ ДОСТАВКИ ИЛИ ДРУГИЕ УБЫТКИ, ВЫЗВАННЫЕ ТАКИМИ
                            ЗАТРУДНЕНИЯМИ.
                        </p>
                        <p>
                            <strong>11.2</strong>. BLAGO ПРЕДЛАГАЕТ ПЛАТФОРМУ ДЛЯ ОБЕСПЕЧЕНИЯ
                            ВЗАИМОДЕЙСТВИЯ ГРУЗООТПРАВИТЕЛЕЙ И ПЕРЕВОЗЧИКОВ, ОДНАКО, НЕ ОКАЗЫВАЕТ
                            УСЛУГИ ПЕРЕВОЗКИ И НЕ ВЫСТУПАЕТ В КАЧЕСТВЕ ПЕРЕВОЗЧИКА, КУРЬЕРА ИЛИ
                            ПОСТАВЩИКА УСЛУГ ПЕРЕВОЗКИ. УСЛУГИ ПЕРЕВОЗКИ, КОТОРЫЕ МОГУТ БЫТЬ
                            ЗАПЛАНИРОВАНЫ ПРИ ИСПОЛЬЗОВАНИИ СЕРВИСА, ОКАЗЫВАЮТ СТОРОННИЕ
                            ПЕРЕВОЗЧИКИ. BLAGO НЕ НЕСЕТ ОТВЕТСТВЕННОСТИ ЗА КАКИЕ БЫ ТО НИ БЫЛО
                            УСЛУГИ ПЕРЕВОЗКИ, ОКАЗЫВАЕМЫЕ ГРУЗООТПРАВИТЕЛЯМ ТАКИМИ СТОРОННИМИ
                            ПЕРЕВОЗЧИКАМИ. НИ ПРИ КАКИХ ОБСТОЯТЕЛЬСТВАХ BLAGO НЕ МОЖЕТ СЧИТАТЬСЯ
                            АГЕНТОМ ИЛИ ПАРТНЕРОМ ПЕРЕВОЗЧИКА ИЛИ ГРУЗООТПРАВИТЕЛЯ. НИ ПРИ КАКИХ
                            ОБСТОЯТЕЛЬСТВАХ ПЕРЕВОЗЧИКИ НЕ МОГУТ СЧИТАТЬСЯ СУБПОДРЯДЧИКАМИ ИЛИ
                            СОТРУДНИКАМИ BLAGO. ЛЮБЫЕ СПОРЫ ГРУЗООТПРАВИТЕЛЕЙ С ПЕРЕВОЗЧИКАМИ ИЛИ
                            ДРУГИМИ ТРЕТЬИМИ ЛИЦАМИ, ВКЛЮЧАЯ, В ТОМ ЧИСЛЕ, ДРУГИХ ПОЛЬЗОВАТЕЛЕЙ
                            СИСТЕМЫ, ПРЕДСТАВЛЯЮТ СОБОЙ СПОРЫ НЕПОСРЕДСТВЕННО МЕЖДУ
                            ГРУЗООТПРАВИТЕЛЯМИ И ТАКИМИ ТРЕТЬИМИ ЛИЦАМИ.
                        </p>
                        <p>
                            <strong>11.3</strong>. МЫ НЕ ДАЕМ НИКАКИХ ГАРАНТИЙ В ОТНОШЕНИИ
                            ПРИГОДНОСТИ, ЗАКОННОСТИ, НОРМАТИВНО-ПРАВОВОГО СООТВЕТСТВИЯ, КАЧЕСТВА ИЛИ
                            ВОЗМОЖНОСТЕЙ ЛЮБЫХ ПЕРЕВОЗЧИКОВ, ГРУЗООТПРАВИТЕЛЕЙ, ПЕРЕВОЗИМЫХ
                            ПРЕДМЕТОВ И УСЛУГ ПЕРЕВОЗКИ, ЗАПЛАНИРОВАННЫХ В РАМКАХ ИСПОЛЬЗОВАНИЯ
                            СЕРВИСА. ИСПОЛЬЗУЯ СЕРВИС, ВЫ МОЖЕТЕ ОКАЗАТЬСЯ В ПОТЕНЦИАЛЬНО ОПАСНЫХ,
                            ПРИЧИНЯЮЩИХ ВРЕД ИНЫХ НЕЖЕЛАТЕЛЬНЫХ СИТУАЦИЯХ (ТО ЖЕ ОТНОСИТСЯ И К ВАШИМ
                            ГРУЗОПЕРЕВОЗКАМ). ВЫ ИСПОЛЬЗУЕТЕ СЕРВИС ПОД СВОЮ ОТВЕТСТВЕННОСТЬ. ВАШЕ
                            ВЗАИМОДЕЙСТВИЕ С ДРУГИМИ ПОЛЬЗОВАТЕЛЯМИ И ТРЕТЬИМИ СТОРОНАМИ ЯВЛЯЕТСЯ
                            ИСКЛЮЧИТЕЛЬНО ВЗАИМОДЕЙСТВИЕМ МЕЖДУ ВАМИ И ТАКИМИ ПОЛЬЗОВАТЕЛЯМИ ИЛИ
                            ТРЕТЬИМИ ЛИЦАМИ. ВЫ СОГЛАШАЕТЕСЬ С ТЕМ, ЧТО BLAGO НЕ НЕСЕТ
                            ОТВЕТСТВЕННОСТИ ЗА УБЫТКИ ИЛИ УЩЕРБ, ПРИЧИНЕННЫЕ В РЕЗУЛЬТАТЕ ТАКОГО
                            ВЗАИМОДЕЙСТВИЯ. В СЛУЧАЕ НАЛИЧИЯ СПОРА МЕЖДУ ВАМИ И КАКИМ-ЛИБО
                            ПОЛЬЗОВАТЕЛЕМ ИЛИ ТРЕТЬИМ ЛИЦОМ, МЫ НЕ ОБЯЗАНЫ ПРИНИМАТЬ УЧАСТИЕ В
                            РАЗРЕШЕНИИ ТАКОГО СПОРА.
                        </p>
                        <p>
                            <strong>11.4</strong>. НАСТОЯЩИМ ВЫ ОТКАЗЫВАЕТЕСЬ ОТ ПРАВ ТРЕБОВАНИЯ И
                            ОСВОБОЖДАЕТЕ BLAGO (И НАШИХ ПОСТАВЩИКОВ, ДОЛЖНОСТНЫХ ЛИЦ, СОТРУДНИКОВ,
                            АГЕНТОВ И ПРАВОПРЕЕМНИКОВ) ОТ ОТВЕТСТВЕННОСТИ В СВЯЗИ С ЛЮБЫМИ ПРОШЛЫМИ,
                            НАСТОЯЩИМИ ИЛИ БУДУЩИМИ СПОРАМИ, ПРЕТЕНЗИЯМИ, РАЗНОГЛАСИЯМИ,
                            ТРЕБОВАНИЯМИ, ПРАВАМИ, ОБЯЗАТЕЛЬСТВАМИ, ИСКАМИ И ОСНОВАНИЯМИ ДЛЯ
                            ПРЕДЪЯВЛЕНИЯ ИСКА ЛЮБОГО ВИДА (ВКЛЮЧАЯ ПРИЧИНЕНИЕ ВРЕДА ЗДОРОВЬЮ, СМЕРТЬ
                            И ИМУЩЕСТВЕННЫЙ ВРЕД), ВОЗНИКАЮЩИМИ В РЕЗУЛЬТАТЕ ИСПОЛЬЗОВАНИЯ ВАМИ
                            СЕРВИСА ИЛИ ОТНОСЯЩИМИСЯ К ДРУГИМ ПОЛЬЗОВАТЕЛЯМ ИЛИ ТРЕТЬИМ ЛИЦАМ, ЗА
                            ИСКЛЮЧЕНИЕМ СЛУЧАЕВ, КОГДА ТАКАЯ ОТВЕТСТВЕННОСТЬ ПРЕДУСМОТРЕНА НАСТОЯЩИМ
                            СОГЛАШЕНИЕМ В ЯВНОЙ ФОРМЕ.
                        </p>
                        <p>
                            В НЕКОТОРЫХ ЮРИСДИКЦИЯХ НЕ РАЗРЕШАЕТСЯ ИСКЛЮЧЕНИЕ ПОДРАЗУМЕВАЕМЫХ
                            ГАРАНТИЙ, ПОЭТОМУ ВЫШЕУКАЗАННОЕ ИСКЛЮЧЕНИЕ МОЖЕТ НЕ ПРИМЕНЯТЬСЯ К ВАМ.
                        </p>
                        <h2>ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</h2>
                        <p>
                            <strong>12.1</strong>. НИ ПРИ КАКИХ ОБСТОЯТЕЛЬСТВАХ МЫ (И НАШИ
                            ПОСТАВЩИКИ) НЕ НЕСЕМ ОТВЕТСТВЕННОСТИ ПЕРЕД ВАМИ ИЛИ КАКИМИ-ЛИБО ТРЕТЬИМИ
                            ЛИЦАМИ ЗА ПРИЧИНЕНИЕ ВРЕДА ЗДОРОВЬЮ, УПУЩЕННУЮ ВЫГОДУ ИЛИ КАКИЕ-ЛИБО
                            КОСВЕННЫЕ, ПРИСУЖДАЕМЫЕ В ПОКАЗАТЕЛЬНОМ ПОРЯДКЕ, ВЫЗВАННЫЕ ОСОБЫМИ
                            ОБСТОЯТЕЛЬСТВАМИ, СЛУЧАЙНЫЕ, ФАКТИЧЕСКИЕ ИЛИ ШТРАФНЫЕ УБЫТКИ,
                            ВОЗНИКАЮЩИЕ В СВЯЗИ С НАСТОЯЩИМ СОГЛАШЕНИЕМ ИЛИ ИСПОЛЬЗОВАНИЕМ ВАМИ
                            СЕРВИСА В НАРУШЕНИЕ ПРАВИЛ ДОРОЖНОГО ДВИЖЕНИЯ ИЛИ ЗАКОНОДАТЕЛЬСТВА О
                            БЕЗОПАСНОСТИ ДВИЖЕНИЯ, ИЛИ НЕВОЗМОЖНОСТЬЮ ИСПОЛЬЗОВАНИЯ СЕРВИСА, ДАЖЕ
                            ЕСЛИ НАМ БЫЛО ИЗВЕСТНО О ВОЗМОЖНОСТИ ВОЗНИКНОВЕНИЯ ТАКИХ УБЫТКОВ.
                            НЕВЗИРАЯ НИ НА КАКИЕ ПОЛОЖЕНИЯ НАСТОЯЩЕГО СОГЛАШЕНИЯ ОБ ОБРАТНОМ, ЗА
                            ИСКЛЮЧЕНИЕМ СЛУЧАЕВ, ПРЕДУСМОТРЕННЫХ РАЗДЕЛОМ 4.2. НАСТОЯЩЕГО
                            СОГЛАШЕНИЯ, НАША ОТВЕТСТВЕННОСТЬ (И ОТВЕТСТВЕННОСТЬ НАШИХ ПОСТАВЩИКОВ)
                            ПЕРЕД ВАМИ ЗА ЛЮБЫЕ УБЫТКИ, ВОЗНИКАЮЩИЕ В СВЯЗИ С НАСТОЯЩИМ СОГЛАШЕНИЕМ
                            ИЛИ СЕРВИСОМ (ПО ЛЮБОЙ ПРИЧИНЕ И ВНЕ ЗАВИСИМОСТИ ОТ ФОРМЫ ДЕЙСТВИЯ), ВО
                            ВСЕХ СЛУЧАЯХ ОГРАНИЧИВАЕТСЯ БОЛЬШЕЙ ИЗ СЛЕДУЮЩИХ СУММ: (A) 50
                            (ПЯТЬДЕСЯТ) ДОЛЛ. США, ИЛИ (B) СУММЫ, КОТОРЫЕ ВЫ УПЛАТИЛИ BLAGO В
                            ТЕЧЕНИЕ ПРЕДШЕСТВУЮЩИХ 12 МЕСЯЦЕВ (ПРИ НАЛИЧИЕ ТАКОВЫХ). НАЛИЧИЕ
                            НЕСКОЛЬКИХ ТРЕБОВАНИЙ НЕ ПРИВОДИТ К УВЕЛИЧЕНИЮ ДАННОГО ОГРАНИЧЕНИЯ.
                        </p>
                        <p>
                            В НЕКОТОРЫХ ЮРИСДИКЦИЯХ НЕ ДОПУСКАЕТСЯ ОГРАНИЧЕНИЕ ИЛИ ИСКЛЮЧЕНИЕ
                            ОТВЕТСТВЕННОСТИ ЗА КОСВЕННЫЕ УБЫТКИ, ПОЭТОМУ ВЫШЕУКАЗАННОЕ ОГРАНИЧЕНИЕ
                            ИЛИ ИСКЛЮЧЕНИЕ МОЖЕТ НЕ ПРИМЕНЯТЬСЯ ПО ОТНОШЕНИЮ К ВАМ; КРОМЕ ЭТОГО, ВЫ
                            МОЖЕТЕ ИМЕТЬ ДРУГИЕ ЗАКОННЫЕ ПРАВА, КОТОРЫЕ РАЗЛИЧАЮТСЯ В ЗАВИСИМОСТИ ОТ
                            ЮРИСДИКЦИИ.
                        </p>
                        <h2>САЙТЫ И РЕКЛАМНЫЕ ОБЪЯВЛЕНИЯ ТРЕТЬИХ ЛИЦ</h2>
                        <p>
                            Сервис может содержать ссылки на сайты, услуги и рекламные объявления
                            третьих лиц (далее совместно именуемые «Сайты и Рекламные объявления
                            третьих лиц»). BLAGO не осуществляет контроль за такими Сайтами и
                            Рекламными объявлениями третьих лиц и не несет ответственности за них.
                            BLAGO предоставляет такие Сайты и Рекламные объявления третьих лиц
                            только для удобства, не просматривает, не утверждает, не контролирует,
                            не одобряет их, а также не предоставляет гарантий и делает никаких
                            заявлений в их отношении. Вы используете все Сайты и Рекламные
                            объявления третьих лиц под свою ответственность. При вашем переходе по
                            ссылке на Сайты и Рекламные объявления третьих лиц применяются
                            соответствующие условия и политики третьих лиц, в том числе их правила
                            обеспечения соблюдения конфиденциальности и сбора данных. До совершения
                            каких-либо сделок в связи с такими Сайтами и Рекламными объявлениями
                            третьих лиц вам необходимо изучить представленную указанными Сайтами и
                            Рекламными объявлениями третьих лиц информацию в необходимом вам и
                            целесообразном для вас объеме.
                        </p>
                        <h2>ПОЛИТИКА В ОБЛАСТИ АВТОРСКИХ ПРАВ</h2>
                        <p>
                            <strong>14.1</strong>. BLAGO уважает интеллектуальную собственность
                            других лиц и просит Пользователей нашего Сервиса поступать таким же
                            образом. В связи с Сервисом мы приняли и применяем политику в области
                            соблюдения законодательства об авторских правах, которая предусматривает
                            удаление любых материалов, нарушающих права других лиц, и прекращение, в
                            соответствующих обстоятельствах, предоставления Сервиса Пользователям,
                            которые неоднократно нарушали права интеллектуальной собственности,
                            включая авторские права. Если вы считаете, что один из наших
                            Пользователей в ходе использования Сервиса нарушает авторские права на
                            какую-либо работу, и намерены удалить материал, предположительно
                            нарушающий авторские права, необходимо направить следующую информацию в
                            форме письменного уведомления нашему уполномоченному представителю на
                            адрес электронной почты, указанной в настоящем Соглашении, или
                            уполномоченному Агенту по авторским правам (при наличии такового): 1.
                            ваша физическая или электронная подпись; 2. идентификация защищенных
                            авторским правом работ, права на которые, по вашему мнению, были
                            нарушены; 3. идентификация материалов, размещенных на нашем Сервисе,
                            которые, по вашему мнению, нарушают авторские права и которые вы просите
                            нас удалить; 4. сведения, позволяющие нам определить местонахождение
                            таких материалов; 5. ваш адрес, номер телефона и адрес электронной
                            почты; 6. заявление о том, что вы добросовестно полагаете, что
                            использование нежелательных материалов не разрешено владельцем авторских
                            прав, его агентом или законодательством; и 7. заявление о том, что
                            информация, содержащаяся в уведомлении, является достоверной и
                            передается под страхом наказания за предоставление заведомо ложных
                            сведений, что вы являетесь владельцем авторских прав, которые
                            предположительно были нарушены, или уполномочены выступать от имени
                            такого владельца. Обратите внимание на то, что любое искажение
                            существенного факта (ложное заявление) в письменном уведомлении
                            автоматически влечет за собой ответственность стороны, подавшей жалобу,
                            за любые убытки, расходы и вознаграждение адвокатов, понесенные нами в
                            связи с письменным уведомлением и заявлением о нарушении авторских прав.
                        </p>
                        {/* <h2>ВНЕСЕНИЕ ИЗМЕНЕНИЙ В НАСТОЯЩЕЕ СОГЛАШЕНИЕ</h2>
                        <p>
                            Изменения в настоящее Соглашение вносятся регулярно, по мере
                            необходимости. Регулярно просматривайте Условия использования Сервиса
                            для того, чтобы быть осведомленным об их изменении. В случае внесения
                            изменений в Условия использования Сервиса мы сделаем соответствующие
                            обновления доступными с помощью Сервиса. BLAGO будет принимать меры для
                            уведомления вас о таких изменениях по электронной почте, но не несет
                            ответственности за непредоставление такого уведомления. Изменения
                            вступают в силу после их опубликования BLAGO. Продолжение использования
                            Сервиса после такого опубликования означает принятие вами таких
                            изменение и согласие соблюдать условия с внесенными в них изменениями.
                            Если вам не понятны какие-либо условия настоящего Соглашения или если у
                            вас имеются вопросы об использовании BLAGO, вы можете обратиться за
                            разъяснениями или задать вопросы, направив сообщение на адрес
                            электронной почты blagotruns@gmail.com.
                        </p> */}
                        <h2>ОБЩИЕ ПОЛОЖЕНИЯ</h2>
                        <p>
                            <strong>16.1</strong>. Разрешение споров. ВНИМАТЕЛЬНО ОЗНАКОМЬТЕСЬ С
                            НАСТОЯЩИМИ ПОЛОЖЕНИЯМИ. ОНИ ОКАЗЫВАЮТ ВОЗДЕЙСТВИЕ НА ВАШИ ПРАВА
                        </p>
                        <p>
                            (a) Любые разногласия, споры, требования, обвинения, претензии или
                            основания для предъявления иска (включая толкование и содержание данного
                            раздела Соглашения, а также отсутствие достаточных правовых оснований
                            для разногласий, споров, требований, обвинений, претензий или оснований
                            иска), возникающие между вами и BLAGO и нашими сотрудниками, агентами
                            или правопреемниками в отношении Сервиса или настоящего Соглашения,
                            подлежат урегулированию в ходе арбитражного разбирательства
                            конфиденциального характера, имеющего обязательную юридическую силу.
                        </p>
                        <p>
                            Настоящим Вы ОТКАЗЫВАЕТЕСЬ ОТ ПРАВА НА ОБРАЩЕНИЕ В СУД для предъявления
                            или защиты своих прав. Решение о ваших правах будет принимать
                            НЕЗАВИСИМЫЙ АРБИТР, а НЕ судья или суд присяжных. Вы имеете право на
                            СПРАВЕДЛИВОЕ СЛУШАНИЕ, НО процедура арбитража ПРОЩЕ И ИМЕЕТ БОЛЬШЕ
                            ОГРАНИЧЕНИЙ, ЧЕМ ПРАВИЛА СУДОПРОИЗВОДСТВА. Решения арбитра являются
                            такими же исполнимыми в судебном порядке, как и судебные постановления;
                            суд проводит ПЕРЕСМОТР таких решений В ОЧЕНЬ ОГРАНИЧЕННОМ КОЛИЧЕСТВЕ
                            СЛУЧАЕВ.
                        </p>
                        <p>
                            В случае возникновения каких-либо споров или требований в связи с
                            настоящим Соглашением или его нарушением, Стороны настоящего Соглашения,
                            признавая свои взаимные интересы, должны провести переговоры друг с
                            другом в целях достижения удовлетворительного решения. Если Стороны не
                            достигнут соглашения в течение 60 дней, то после уведомления любой из
                            Сторон другой Стороны любой такой спор или любое такое требование
                            подлежит разрешению в арбитражном порядке в соответствии с Арбитражным
                            регламентом ЮНСИТРАЛ, действующим на дату настоящего Соглашения.
                        </p>
                        <p>Назначающим органом является Лондонский международный третейский суд;</p>
                        <ul>
                            <li>спор рассматривается одним арбитром; </li>
                            <li>
                                местом проведения арбитражного разбирательства является Лондон,
                                Англия; применимым правом – право Англии и Уэльса; 
                            </li>
                            <li>арбитражное разбирательство проводится на английском языке.</li>
                            <li>
                                арбитражное разбирательство будет проводиться с помощью
                                видеоконференции или других подходящих виртуальных электронных
                                средств во время, удобное для всех Сторон, чтобы можно было
                                обеспечить возможность участия представителей Сторон, не проживающих
                                в Лондоне.
                            </li>
                        </ul>

                        <p>
                            <strong>16.2</strong>. Форс-мажор. Задержка в выполнении каких-либо
                            обязанностей или обязательств любой из сторон (кроме платежных
                            обязательств) не считается нарушением настоящего Соглашения, если такая
                            задержка вызвана трудовым спором, нехваткой материалов, пожаром,
                            землетрясением, наводнением или каким-либо другим событием, не зависящим
                            от воли такой стороны.
                        </p>
                        <p>
                            <strong>16.3</strong>. Исчерпывающий характер Соглашения. Настоящее
                            Соглашение, включая, в том числе, любые применимые Дополнительные
                            тарифы, Стандартные операционные процедуры и (или) Заявки на выполнение
                            работ, включенные в Соглашение посредством ссылки, представляет собой
                            полный объем договоренностей между вами и нами в отношении использования
                            Сервиса. Неосуществление или необеспечение нами исполнения какого-либо
                            права или положения настоящего Соглашения не означает отказ от такого
                            права или положения. Заглавия разделов в настоящем Соглашении
                            предназначены только для удобства и не имеют юридической или договорной
                            силы. Слово «включая» означает «включая, в том числе». Если какое-либо
                            положение настоящего Соглашения будет по какой бы то ни было причине
                            признано недействительным или неисполнимым в судебном порядке, это не
                            повлияет на другие положения настоящего Соглашения, и недействительное
                            или неисполнимое в судебном порядке положение будет считаться измененным
                            таким образом, чтобы оно было действительным и исполнимым в судебном
                            порядке в максимально допустимой законодательством степени. Настоящее
                            Соглашение может быть оформлено в нескольких экземплярах.
                        </p>
                        <p>
                            <strong>16.4</strong>. Независимый подрядчик. В отношениях с BLAGO вы
                            являетесь независимым подрядчиком; ни одна из сторон не является
                            агентом, сотрудником или партнером другой стороны. Вы принимаете на себя
                            полную ответственность за уплату всех государственных и федеральных
                            налогов, отчислений, страховых взносов (включая компенсацию работникам,
                            пособие по безработице, пособие по инвалидности, пенсионное страхование
                            и социальное страхование) и выполнение любых других финансовых
                            обязательств, возникающих у вас в связи с оказанием услуг при
                            использовании нашего Сервиса. Вы не являетесь и не будете считаться
                            агентом, законным представителем, участником совместного предприятия,
                            франшизодателем, франшизополучателем или партнером BLAGO для каких-либо
                            целей. Вы не вправе заключать договоры, делать заявления или
                            предоставлять гарантии в интересах компании BLAGO или принимать
                            обязательства от ее имени.
                        </p>
                        <p>
                            <strong>16.5</strong>. Переуступка. Настоящее Соглашение, а также ваши
                            права и обязанности по нему не могут быть переданы вами посредством
                            переуступки, по договору субподряда или иным образом без
                            предварительного письменного согласия BLAGO; любая попытка передачи
                            посредством переуступки, по договору субподряда или иным образом в
                            нарушение данного положения будет являться недействительной. Условия
                            настоящего Соглашения имеют обязательную силу для правопреемников.
                        </p>
                        <p>
                            <strong>16.6. Публичное упоминание</strong>. Настоящим вы разрешаете
                            BLAGO указывать вас как клиента BLAGO или Пользователя наших Услуг и
                            воспроизводить ваше имя и логотип на Сайте и в любых других
                            маркетинговых материалах.
                        </p>
                        <p>
                            <strong>16.7. Противоречия</strong>. В случае возникновения какого-либо
                            противоречия или несоответствия между условиями настоящего Соглашения и
                            условиями какого-либо коносамента, подтверждения доставки или любого
                            другого транспортно-сопроводительного документа, условия настоящего
                            Соглашения имеют преимущественную юридическую силу. В случае
                            возникновения противоречия между настоящими Условиями использования
                            Сервиса и каким-либо отдельным соглашением для целей определения услуг
                            перевозки, оказываемых компанией BLAGO, условия такого отдельного
                            соглашения имеют преимущественную юридическую силу, однако, все не
                            противоречащие ему условия настоящего Соглашения также применяются.
                            Настоящее Соглашение составлено в на английском языке с переводом на
                            русский язык. В случае разночтений превалируюшей является аглийская
                            версия.
                        </p>
                        <p>
                            <strong>16.8. Электронные средства связи</strong>. Вы и BLAGO
                            обмениваетесь сообщениями с использованием электронных средств связи,
                            включая использование вами Сервиса, направление нам электронных писем,
                            опубликование BLAGO уведомлений в Сервисе, направление вам электронных
                            писем. В целях выполнения настоящего Соглашения вы: (а) соглашаетесь
                            получать сообщения от BLAGO в электронной форме; и (b) соглашаетесь с
                            тем, что все условия, соглашения, уведомления, раскрытие информации и
                            другие сообщения, которые BLAGO направляет вам в электронном виде,
                            удовлетворяют всем юридическим требованиям, которым они удовлетворяли
                            бы, если бы были составлены в бумажной форме. Вышеизложенные положения
                            не влияют на ваши права, отказ от которых невозможен.
                        </p>
                        {/* <p>
                            <strong>16.9. Контактная информация</strong>:
                        </p>
                        <p>BLAGO OÜ  </p>
                        <p>Адрес: ______</p>
                        <p>Электронная почта: blagotruns@gmail.com</p> */}
                    </>
                )}
            </div>
            <Button onClick={handleClose}>{t("dialog.finishedButton")}</Button>
        </Popup>
    );
};

export default Terms;
